// import { find } from 'lodash-es'
import NProgress, { set } from 'nprogress'
import { SassArgumentList } from 'sass'
import { stripHtml } from 'string-strip-html'
import styled from 'styled-components/macro'
import React, { useEffect, useRef, useState } from 'react'
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share'
import Slider from 'react-slick'
// import {
//   ReactZoomPanPinchRef,
//   TransformComponent,
//   TransformWrapper,
// } from 'react-zoom-pan-pinch'
import {
  getGroupsWithMemberShips,
  getPhenomenaTypes,
} from '@futures-platform/connectors/drupal-api'
import { getUserId } from '@futures-platform/connectors/session'
import { requestTranslation } from '@futures-platform/i18n'
import { ContentCardType } from '@futures-platform/ui'
import { Loading } from '@futures-platform/ui'
import CardHeaderOnMainContent from './CardHeaderOnMainContent'
// import { OptionDropdown } from '@futures-platform/ui'
// import { Add, Fullscreen, Remove } from '@mui/icons-material'
import CardHeaderScenarioOnMainContent from './CardHeaderScenarioOnMainContent'
import ContentCard from './components/ContentCard/index'
import FlagIcon from './components/FlagIcon'
import InformationModal from './components/InformationModal'
import InformationModal2 from './components/InformationModal2'
import SampleNextArrow from './components/SampleNextArrow'
import SamplePreviousArrow from './components/SamplePreviousArrow'
import { getPhenomenonUrl } from './helpers/contentCard'
import {
  coordinationCalculation,
  isColliding,
  isInside,
} from './helpers/coordinationCalculation'
import { normalisedTimeFormat } from './helpers/helpers'
import { spotlightAPIs } from './helpers/spotLightAPIs'
import useOnClickOutside from './hooks/useOnClickOutside'
import { mockData } from './spotlight'

const hostname = 'https://go2.futuresplatform.com'

const App = ({ gid: gidProp, newsIdProp, isAuthed, type }) => {
  const [newsId, setnewsId] = useState(() => newsIdProp)
  const [typeState, settypeState] = useState(() => type)

  const spotLightListRef = useRef([])
  const [isHover, setIsHover] = useState(false)
  const [isHoverShareBtn, setIsHoverShareBtn] = useState(false)
  const [isHoverBackBtn, setisHoverBackBtn] = useState(false)
  const [isHoverNextBtn, setisHoverNextBtn] = useState(false)
  const [isHoverSwitchToMainNews, setisHoverSwitchToMainNews] = useState(false)
  const [isHubSpotBtnHover, setisHubSpotBtnHover] = useState(false)

  const [tags, setTags] = useState([])
  const [isSharedModalOpened, setisSharedModalOpened] = useState(false)
  const [newsItem, setnewsItem] = useState(null)
  const [isNewsBookMarked, setisNewsBookMarked] = useState(false)

  const shareWrapperRef = useRef()
  const sharedBtnRef = useRef()
  const reflectorRef = useRef()
  // const [selectedGroup1, setSelectedGroup1] = useState()
  // const [selectedGroup2, setSelectedGroup2] = useState()
  // const [selectedGroup3, setSelectedGroup3] = useState()
  const [phenTypes, setphenTypes] = useState()
  const [gid, setgid] = useState(gidProp)
  // const [
  //   eitherNextOrBackNarrowBtnClicked,
  //   seteitherNextOrBackNarrowBtnClicked,
  // ] = useState(0)

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    prevArrow: <SamplePreviousArrow />,
    nextArrow: <SampleNextArrow />,

    // arrows: false,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  NProgress.configure({ minimum: 0.1 })

  const closeSocialBtnsHAndler = () => {
    setisSharedModalOpened(false)
  }

  // data?.spotLight?.source

  useOnClickOutside(shareWrapperRef, sharedBtnRef, closeSocialBtnsHAndler)

  const shareSocialBtnsHandler = (news1, event) => {
    event.preventDefault()
    event.stopPropagation()
    // if (event && event.stopPropagation) event.stopPropagation()

    // event.stopImmediatePropagation()
    // setisOpenSocialBtns(() => !isOpenSocialBtns)
    setnewsItem(() => news1)

    //open/close this news' modal
    setisSharedModalOpened(() => !isSharedModalOpened)
  }
  const firstDataFetcherRef = useRef(true)

  const [recomendedNewsState, setrecomendedNewsState] = useState()
  const [recomendedPhenState, setrecomendedPhenState] = useState()

  const [isNeed2ScrollToMainNews, setisNeed2ScrollToMainNews] = useState(false)
  const [groupsIds, setgroupsIds] = useState([])
  useEffect(() => {
    const fetcher = async () => {
      const res = await getGroupsWithMemberShips()
      const temp = !!res?.length
        ? res?.map((item) => {
            return item?.id
          })
        : [0]
      !!res?.length && setgroupsIds(() => temp)
    }
    if (!!isAuthed) {
      fetcher()
    } else {
      setgroupsIds(() => [0])
    }
  }, [isAuthed])

  useEffect(() => {
    const fetcher = async () => {
      NProgress.start()
      NProgress.set(0.5)

      try {
        const payload = {
          groups: !!isAuthed ? [...groupsIds, 0] : groupsIds,
          userId: !!isAuthed ? getUserId() : -1,
          // 'news-id': newsId,
          // 'tag-1': null,
          // 'tag-2': null,
          // 'tag-3': null,
        }

        const [
          spotlightRes,
          phenomenonType,
          getStatus1BookmarkNews,
          crowdsourcedData,
        ] = await Promise.all([
          spotlightAPIs.getSpotLight(typeState, newsId, payload),
          // mockData,
          !!isAuthed
            ? getPhenomenaTypes(gidProp || 0)
            : spotlightAPIs.getPhenomenaTypesGroup0(),
          !!isAuthed
            ? spotlightAPIs.getStatus1BookmarkNews(
                `${gidProp || 0}/${typeState}/${newsId}`,
              )
            : null,
          // fetcher.getStatistics(),
          null,
        ])

        const spotlight = !!spotlightRes ? { ...spotlightRes } : {}
        NProgress.done(true)
        NProgress.remove()
        setnewsItem(() => spotlight.data?.source)

        const bookmarkEntityUriSplited =
          !!getStatus1BookmarkNews?.data.length &&
          getStatus1BookmarkNews?.data[0]?.entityUri?.split('/')

        const newsIdFromEntityUriRes = !!bookmarkEntityUriSplited
          ? bookmarkEntityUriSplited[4]
          : false

        if (!!newsIdFromEntityUriRes && newsIdFromEntityUriRes === newsId) {
          setisNewsBookMarked(true)
        } else {
          setisNewsBookMarked(false)
        }
        const lang = spotlight.data?.source?.language
        const recommended_phenomenaTemp = [].concat(
          spotlight.data?.recommeded_phenomena,
        )
        let recommeded_phenomena =
          !!recommended_phenomenaTemp?.length &&
          recommended_phenomenaTemp
            ?.filter((phen) => {
              if (
                !!phen?.content?.time_range?.min &&
                !!phen?.content?.time_range?.max
              ) {
                return phen
              } else if (!!phen?.content && !phen?.content?.time_range?.min) {
                phen.content['time_range'] = {
                  min: 2040,
                  max: 2040,
                }
                return phen
              }
            })
            ?.filter((n) => {
              if (n?.language === lang) return n
            })
            ?.slice(0, 12)
        let recommeded_phenomenaNotTimeRange = []

        if (
          !recommeded_phenomena?.length ||
          recommeded_phenomena?.length < 12
        ) {
          let i = 0
          while (
            !!recommeded_phenomena?.length &&
            recommeded_phenomena?.length < 13 &&
            i < recommeded_phenomena?.length
          ) {
            // eslint-disable-next-line no-loop-func
            const isNotSame = recomended_phenomena?.every((rn) => {
              if (
                String(rn?.id) ===
                String(recommeded_phenomenaNotTimeRange[i]?.id)
              ) {
                return false
              }
            })

            if (!!isNotSame) {
              !!recommeded_phenomenaNotTimeRange[i] &&
                recommeded_phenomena?.push(recommeded_phenomenaNotTimeRange[i])
            }
            i += 1
          }
        }
        // recommeded_phenomena = recommeded_phenomena?.filter((n) => {
        //   if (n?.language === lang) return n
        // })
        setgid(() => gidProp || 0)
        setphenTypes(() => (!!isAuthed ? phenomenonType : phenomenonType?.data))
        setrecomendedNewsState(() => spotlight.data?.recommedded_news)
        setrecomendedPhenState(() => recommeded_phenomena)
        setTags(() => spotlight.data?.tags)
        // setFirstDataFetcher(() => false)

        setisNeed2ScrollToMainNews(() => true)
        spotLightListRef.current = [
          {
            spotlight: spotlight.data,
            phenomenonType: !!isAuthed ? phenomenonType : phenomenonType?.data,
            getStatus1BookmarkNews: getStatus1BookmarkNews?.data,
          },
        ]

        const mainNewsElm = document.querySelector('#year-2025')
        firstDataFetcherRef.current = false
        if (!!mainNewsElm) {
          mainNewsElm?.scrollIntoView({
            behavior: 'smooth',
          })
        }
      } catch (error) {
        console.error(error)
        firstDataFetcherRef.current = false
        setisNeed2ScrollToMainNews(() => true)
      }
    }
    !!newsId &&
      !!firstDataFetcherRef.current &&
      !!groupsIds?.length &&
      // !!spotLightListRef.current?.length &&
      fetcher()
    return () => {
      setisNeed2ScrollToMainNews(() => false)
    }
  }, [gidProp, newsId, isAuthed, groupsIds])

  // this is for the first scrolling or when clicking to discover the secondary news
  useEffect(() => {
    if (
      !!newsItem &&
      !firstDataFetcherRef.current &&
      !!isNeed2ScrollToMainNews
    ) {
      const mainNewsElm = document.querySelector('#year-2025')

      if (!!mainNewsElm) {
        mainNewsElm?.scrollIntoView({
          behavior: 'smooth',
        })
      }
      setisNeed2ScrollToMainNews(() => false)
    }
    return () => {
      setisNeed2ScrollToMainNews(() => false)
    }
  }, [newsItem, isNeed2ScrollToMainNews])

  // useEffect(() => {
  //   !!tags?.length &&
  //     setSelectedGroup1(() => {
  //       return {
  //         value: tags[0],
  //         label: tags[0],
  //       }
  //     })
  // }, [tags])
  // useEffect(() => {
  //   !!tags?.length &&
  //     tags?.length > 1 &&
  //     setSelectedGroup2(() => {
  //       return {
  //         value: tags[1],
  //         label: tags[1],
  //       }
  //     })
  // }, [tags])
  // useEffect(() => {
  //   !!tags?.length &&
  //     tags?.length > 2 &&
  //     setSelectedGroup3(() => {
  //       return {
  //         value: tags[2],
  //         label: tags[2],
  //       }
  //     })
  // }, [tags])

  // const max = 2080
  // const thisYear = new Date().getFullYear()
  const recomended_phenomenaTemp = React.useMemo(() => {
    let countPhenOver2080 = 0
    let finalPhen = []
    const temp1 = !!recomendedPhenState?.length ? [...recomendedPhenState] : []

    !!temp1?.length &&
      temp1?.forEach((phen, index) => {
        // const temp1 = Object.fromEntries(
        //   Object.entries({}).filter(
        //     ([key, value]) => key?.toString() === phen?.id?.toString(),
        //   ),
        // )

        // const statictis = temp1[phen?.id]
        // console.log(11111, statictis)

        // if (!!statictis) {
        //   phen['statistic'] = statictis
        // }
        // phen['crowdsourced'] = !!statictis
        //   ? String(statictis?.['year_median'])?.split('.')[0]
        //   : null
        const mediumTimeRange = Number(
          !!phen?.content?.time_range?.max
            ? (phen?.content?.time_range?.max +
                phen?.content?.time_range?.min) /
                2
            : 2081,
        )

        phen['mediumTimeRange'] = mediumTimeRange
        if (mediumTimeRange > 2080) {
          phen['over_2080'] = true
          countPhenOver2080 = countPhenOver2080 + 1

          phen['position_over_2080'] = countPhenOver2080
        }
      })

    !!temp1?.length &&
      temp1?.map((phen) => {
        const sameYear =
          !!temp1?.length &&
          temp1
            .filter((obj) => {
              if (!!phen?.mediumTimeRange && !!obj?.mediumTimeRange) {
                return phen?.mediumTimeRange === obj?.mediumTimeRange
              }
            })
            ?.sort((a, b) => {
              return Number(a?.score) - Number(b?.score)
            })

        if (!!sameYear?.length) {
          let newArr =
            !!sameYear?.length &&
            temp1.filter(function (itm) {
              return itm?.mediumTimeRange !== phen?.mediumTimeRange
            })
          sameYear?.forEach((phen2, index) => {
            phen2['length'] = sameYear?.length || 0
            phen2['position'] = index
            newArr?.push(phen2)
          })
          finalPhen = newArr
        }
      })
    finalPhen?.forEach((phen) => {
      if (!!phen?.['over_2080']) phen['length'] = countPhenOver2080
    })
    return finalPhen
  }, [recomendedPhenState])

  const recomended_phenomena = React.useMemo(() => {
    const temp = [...recomended_phenomenaTemp]
    const temp2 = coordinationCalculation(temp)
    return temp2
  }, [recomended_phenomenaTemp])

  function getRandomNumber(min, max) {
    return Math.random() * (max - min) + min
  }

  const [widthOfView, setwidthOfView] = useState(0)

  useEffect(() => {
    let recommendedPhenElms = document.querySelectorAll('.related-Phenomena')
    recommendedPhenElms = Array.prototype.slice.call(recommendedPhenElms)
    if (!!recommendedPhenElms?.length) {
      for (let i = 0; i < recommendedPhenElms.length; i++) {
        let isOverlapping = false
        let attemptCount = 0
        const leftPosition = Number(
          recommendedPhenElms[i].style.left?.split('%')[0],
        )
        isOverlapping =
          !!recommendedPhenElms?.length &&
          recommendedPhenElms?.some((a) => {
            const isCollidingCheckedFirst =
              isColliding(recommendedPhenElms[i], a) ||
              isInside(recommendedPhenElms[i], a)
            if (
              (!!isCollidingCheckedFirst &&
                !recommendedPhenElms[i].isSameNode(a) &&
                recommendedPhenElms[i]?.innerText !== a?.innerText) ||
              leftPosition > 80
            ) {
              return true
            }
          })
        if (!!isOverlapping) {
          do {
            let randomLeft = getRandomNumber(15, 90)
            let a = Number(recommendedPhenElms[i].style.top?.split('p')[0])
            if (a > -25 && a < 410) {
              recommendedPhenElms[i].style.top = a + 1 + 'px'
            } else if (a >= 410) {
              recommendedPhenElms[i].style.top = a - 1 + 'px'
            }

            recommendedPhenElms[i].style.left = randomLeft + '%'
            isOverlapping = false
            for (let j = 0; j < i; j++) {
              const leftPosition = Number(
                recommendedPhenElms[i].style.left?.split('%')[0],
              )
              const isCollidingChecked =
                isColliding(recommendedPhenElms[i], recommendedPhenElms[j]) ||
                isInside(recommendedPhenElms[i], recommendedPhenElms[j]) ||
                leftPosition > 80
              if (
                !!isCollidingChecked &&
                !recommendedPhenElms[i].isSameNode(recommendedPhenElms[j]) &&
                recommendedPhenElms[i]?.innerText !==
                  recommendedPhenElms[j]?.innerText
              ) {
                isOverlapping = true
                break
              }
            }
          } while (++attemptCount < 99 && isOverlapping)
        }
      }
    }
  }, [recomended_phenomena, widthOfView])
  const [isOptionDropdown1Opened, setisOptionDropdown1Opened] = useState(false)
  const [isOptionDropdown2Opened, setisOptionDropdown2Opened] = useState(false)

  const [isOptionDropdown3Opened, setisOptionDropdown3Opened] = useState(false)

  const dropdownOptions = React.useMemo(() => {
    const temp =
      !!tags?.length &&
      tags?.map((tag) => {
        return {
          value: tag,
          label: tag,
        }
      })

    return temp
  }, [tags])
  // const recommendedNews = React.useMemo(() => {
  //   const a =
  //     !!recomendedNewsState?.length &&
  //     recomendedNewsState?.filter((n) => n?.id !== newsId)
  //   return a || recomendedNewsState || []
  // }, [newsId, recomendedNewsState])

  const newsData = React.useMemo(() => {
    return newsItem
  }, [newsItem])
  const [openFullScreenMode, setOpenFullScreenMode] = useState(false)
  const wrapperChartForFullscreenMode =
    document?.getElementById('spot-light-wrapper')
  const uA = navigator.userAgent
  const vendor = navigator.vendor
  const isSafari =
    /Safari/i.test(uA) &&
    /Apple Computer/.test(vendor) &&
    !/Mobi|Android/i.test(uA)
  const prefixes = !!isSafari ? 'webkit' : ''
  const isFullScreen = () => {
    return !!(
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    )
  }
  const isFullScreenInSafari = () => {
    // eslint-disable-next-line no-restricted-globals
    return Math.abs(screen.width - window.innerWidth) < 10
  }
  const fullscreenchanged = () => {
    if ((!isFullScreen() || !isFullScreenInSafari()) && !!openFullScreenMode) {
      closeFullScreenModeHandle()
    }
  }
  document.addEventListener(prefixes + 'fullscreenchange', fullscreenchanged)
  const handleFullscreenMode = () => {
    try {
      if (document.requestFullscreen) {
        wrapperChartForFullscreenMode.requestFullscreen()
      } else if (wrapperChartForFullscreenMode.mozRequestFullScreen) {
        wrapperChartForFullscreenMode.mozRequestFullScreen()
      } else if (wrapperChartForFullscreenMode.webkitRequestFullScreen) {
        wrapperChartForFullscreenMode.webkitRequestFullScreen()
      } else if (wrapperChartForFullscreenMode.msRequestFullscreen) {
        /* IE11 */
        wrapperChartForFullscreenMode.msRequestFullscreen()
      }
    } catch (error) {}
  }
  const handleExitFullScreenMode = () => {
    try {
      if (document.fullscreenElement) {
        document?.exitFullscreen()
        wrapperChartForFullscreenMode?.exitFullscreen()
      } else if (document.webkitFullscreenElement) {
        /* Safari */
        document?.webkitExitFullscreen()
      } else if (document.mozFullScreenElement) {
        /* IE11 */
        document?.msExitFullscreen()
      } else if (document?.cancelFullScreen) {
        /* Safari */
        document?.cancelFullScreen()
      } else if (document?.mozCancelFullScreen) {
        /* Safari */
        document?.mozCancelFullScreen()
      } else if (document?.cancelFullScreen) {
        /* Safari */
        document?.cancelFullScreen()
      } else if (document?.webkitCancelFullScreen) {
        /* Safari */
        document?.webkitCancelFullScreen()
      }
    } catch (error) {}
  }

  const openFullScreenModeHandle = () => {
    handleFullscreenMode()
    setOpenFullScreenMode(true)
  }
  const closeFullScreenModeHandle = () => {
    handleExitFullScreenMode()
    setOpenFullScreenMode(false)
  }

  // (!!newsItem || !!recomendedNewsState || recomendedPhenState) && NProgress.done(true)
  // (!!newsItem || !!recomendedNewsState || recomendedPhenState) && NProgress.remove()

  const newsBookmarkHandler = () => {
    // const indexAt = spotLightListRef.current?.reduce(function (
    //   cur,
    //   val,
    //   index,
    // ) {
    //   if (val?.spotlight?.source?.id === newsId && cur === -1) {
    //     return index
    //   }
    //   return cur
    // },
    // -1)

    if (!!isNewsBookMarked) {
      spotlightAPIs.deleteBookmarkNews(`${gid || 0}/${typeState}/${newsId}`)
    } else {
      spotlightAPIs.addBookmarkNews({
        entityUri: `/bookmark/${gid || 0}/${typeState}/${newsId}`,
        title: newsItem?.content?.title,
      })
    }
    setisNewsBookMarked(() => !isNewsBookMarked)
  }

  const eventTimeoutRef = React.useRef(null)

  const calcSizeRateTabWrapper = () => {
    setwidthOfView(() => document.body.clientWidth)
  }

  React.useEffect(() => {
    calcSizeRateTabWrapper()
    return () => {
      window.removeEventListener('resize', calcSizeRateTabWrapper)
    }
  }, [])

  let paddingWrapper = '3.75rem'
  if (widthOfView <= 700 && widthOfView > 450) paddingWrapper = '0.375rem'
  else if (widthOfView <= 450 && widthOfView >= 400) paddingWrapper = '0.25rem'
  else if (widthOfView < 400) paddingWrapper = '0.1875rem'
  try {
    window.addEventListener(
      'resize',
      function () {
        // clearTimeOut() resets the setTimeOut() timer
        // due to this the function in setTimeout() is
        // fired after we are done resizing
        clearTimeout(eventTimeoutRef.current)

        // setTimeout returns the numeric ID which is used by
        // clearTimeOut to reset the timer
        eventTimeoutRef.current = setTimeout(calcSizeRateTabWrapper, 200)
      },
      false,
    )
  } catch (error) {}

  const [isVideoModalOpened, setisVideoModalOpened] = React.useState(false)
  const [showVideoSpotLightCounted, setshowVideoSpotLightCounted] =
    React.useState(0)

  useEffect(() => {
    const showVideoSpotLightCountedTemp = localStorage.getItem(
      'show-spot-light-video-count',
    )
    if (
      !showVideoSpotLightCountedTemp ||
      Number(showVideoSpotLightCountedTemp) === 0
    ) {
      localStorage.setItem('show-spot-light-video-count', 1)
      setshowVideoSpotLightCounted(() => 1)
    } else {
      localStorage.setItem(
        'show-spot-light-video-count',
        Number(showVideoSpotLightCountedTemp) + 1,
      )
      setshowVideoSpotLightCounted(
        () => Number(showVideoSpotLightCountedTemp) + 1,
      )
    }

    if (Number(showVideoSpotLightCountedTemp) < 2) {
      setisVideoModalOpened(() => true)
    }
  }, [])

  const videoModalClosedHandler = () => {
    setisVideoModalOpened(() => false)
    localStorage.setItem('show-spot-light-video-count', 2)
  }

  const nextBtnNewsHandler = async () => {
    const indexAt = spotLightListRef.current?.findIndex(
      (x) => x?.spotlight?.source?.id === newsId,
    )

    try {
      const spotlight = spotLightListRef.current[indexAt + 1]?.spotlight
      let typeTemp = 'news'
      switch (spotlight?.source.type) {
        case 'news-feed-item':
          typeTemp = 'news'
          break
        case 'phenomenon':
          typeTemp = 'phenomenon'
          break
        case 'scenario-card':
          typeTemp = 'scenario'
          break
      }
      settypeState(() => typeTemp)
      setnewsId(() => spotlight?.source?.id)
      const phenomenonType =
        spotLightListRef.current[indexAt + 1]?.phenomenonType
      const getStatus1BookmarkNews =
        // spotLightListRef.current[indexAt + 1]?.getStatus1BookmarkNews
        !!isAuthed
          ? await spotlightAPIs.getStatus1BookmarkNews(
              `${gidProp || 0}/${typeTemp}/${spotlight?.source?.id}`,
            )
          : null

      const bookmarkEntityUriSplited =
        !!getStatus1BookmarkNews?.data?.length &&
        getStatus1BookmarkNews?.data[0]?.entityUri?.split('/')

      const newsIdFromEntityUriRes = !!bookmarkEntityUriSplited
        ? bookmarkEntityUriSplited[4]
        : false

      if (newsIdFromEntityUriRes === spotlight?.source?.id) {
        setisNewsBookMarked(true)
      } else {
        setisNewsBookMarked(false)
      }

      const recommeded_phenomena =
        !!spotlight?.recommeded_phenomena?.length &&
        spotlight?.recommeded_phenomena
          ?.filter((phen) => {
            if (
              !!phen?.content?.time_range?.min &&
              !!phen?.content?.time_range?.max
            )
              return phen
          })
          ?.filter((n) => {
            if (n?.language === spotlight?.source?.language) return n
          })
          ?.slice(0, 12)

      NProgress.done(true)
      NProgress.remove()
      setnewsItem(() => spotlight?.source)
      setgid(() =>
        !!spotlight?.source?.groups?.length ? spotlight?.source?.groups[0] : 0,
      )

      setphenTypes(() => phenomenonType)
      setrecomendedNewsState(() => spotlight?.recommedded_news)
      setrecomendedPhenState(() => recommeded_phenomena)
      setTags(() => spotlight?.tags)
    } catch (error) {}
  }
  const backBtnNewsHandler = async () => {
    const indexAt = spotLightListRef.current?.reduce(function (
      cur,
      val,
      index,
    ) {
      if (val?.spotlight?.source?.id === newsId && cur === -1) {
        return index
      }
      return cur
    },
    -1)

    try {
      const spotlight = spotLightListRef.current[indexAt - 1]?.spotlight
      let typeTemp = 'news'
      switch (spotlight?.source.type) {
        case 'news-feed-item':
          typeTemp = 'news'
          break
        case 'phenomenon':
          typeTemp = 'phenomenon'
          break
        case 'scenario-card':
          typeTemp = 'scenario'
          break
      }
      settypeState(() => typeTemp)
      setnewsId(() => spotlight?.source?.id)
      const phenomenonType =
        spotLightListRef.current[indexAt - 1]?.phenomenonType
      const getStatus1BookmarkNews =
        // spotLightListRef.current[indexAt - 1]?.getStatus1BookmarkNews
        !!isAuthed
          ? await spotlightAPIs.getStatus1BookmarkNews(
              `${gidProp || 0}/${typeTemp}/${spotlight?.source?.id}`,
            )
          : null

      const bookmarkEntityUriSplited =
        !!getStatus1BookmarkNews?.data.length &&
        getStatus1BookmarkNews?.data[0]?.entityUri?.split('/')

      const newsIdFromEntityUriRes = !!bookmarkEntityUriSplited
        ? bookmarkEntityUriSplited[4]
        : false

      if (newsIdFromEntityUriRes === spotlight?.source?.id) {
        setisNewsBookMarked(true)
      } else {
        setisNewsBookMarked(false)
      }

      const recommeded_phenomena =
        !!spotlight?.recommeded_phenomena?.length &&
        spotlight?.recommeded_phenomena
          ?.filter((phen) => {
            if (
              !!phen?.content?.time_range?.min &&
              !!phen?.content?.time_range?.max
            )
              return phen
          })
          ?.filter((n) => {
            if (n?.language === spotlight?.source?.language) return n
          })
          ?.slice(0, 12)

      NProgress.done(true)
      NProgress.remove()
      setnewsItem(() => spotlight?.source)

      setgid(() =>
        !!spotlight?.source?.groups?.length ? spotlight?.source?.groups[0] : 0,
      )

      setphenTypes(() => phenomenonType)
      setrecomendedNewsState(() => spotlight?.recommedded_news)
      setrecomendedPhenState(() => recommeded_phenomena)
      setTags(() => spotlight?.tags)
    } catch (error) {}
  }

  const isBackNarrowBtnDisabled = React.useMemo(() => {
    const indexAt = spotLightListRef.current?.reduce(function (
      cur,
      val,
      index,
    ) {
      if (val?.spotlight?.source?.id === newsId && cur === -1) {
        return index
      }
      return cur
    },
    -1)

    if ((spotLightListRef.current?.length >= 1 && indexAt < 0) || indexAt > 0)
      return false
    else return true
  }, [newsId])

  const isNextNarrowBtnDisabled = React.useMemo(() => {
    const indexAt = spotLightListRef.current?.reduce(function (
      cur,
      val,
      index,
    ) {
      if (val?.spotlight?.source?.id === newsId && cur === -1) {
        return index
      }
      return cur
    },
    -1)

    if (
      indexAt > -1 &&
      Number(indexAt) < spotLightListRef.current?.length - 1 &&
      spotLightListRef.current?.length > 1
    ) {
      return false
    } else return true
  }, [newsId])

  const [isInfoModalShown, setisInfoModalShown] = useState(false)

  const infoIconHandler = () => {
    setisInfoModalShown(() => true)
  }

  // const elm = reflectorRef.current
  // const heightOfReflector = useMemo(() => {
  //   if (!!newsItem && elm) {
  //     return elm.offsetHeight
  //   }
  // }, [newsItem, elm])

  const dataUri = React.useMemo(() => {
    if (!isAuthed || !newsData?.id || !newsData?.groups?.length) {
      return null
    } else {
      return typeState === 'phenomenon'
        ? `fp:phen-card-app/arrows/${newsData?.groups[0]}/null/${newsData?.id}`
        : typeState === 'scenario'
        ? 'fp-scenario-card/' +
          newsData?.groups[0] +
          '/' +
          (newsData?.content?.scenarioSetId || 'undefined') +
          '/' +
          newsData?.id
        : ''
    }
  }, [
    isAuthed,
    newsData?.content?.scenarioSetId,
    newsData?.groups,
    newsData?.id,
    typeState,
  ])

  const dataHref = React.useMemo(() => {
    if (!isAuthed || !newsData?.id || !newsData?.groups?.length) {
      return null
    } else {
      return typeState === 'phenomenon'
        ? '/fp-phenomena/' + newsData?.id + '/?group=' + newsData?.groups[0]
        : typeState === 'scenario'
        ? 'fp-scenario-card/' +
          newsData?.groups[0] +
          '/' +
          (newsData?.content?.scenarioSetId || 'undefined') +
          '/' +
          newsData?.id
        : ''
    }
  }, [
    isAuthed,
    newsData?.content?.scenarioSetId,
    newsData?.groups,
    newsData?.id,
    typeState,
  ])
  const classNameMainContent = React.useMemo(() => {
    if (!isAuthed || !newsData?.id) {
      return null
    } else {
      return typeState === 'phenomenon'
        ? 'content-card left'
        : typeState === 'scenario'
        ? 'scenario-link'
        : ''
    }
  }, [isAuthed, newsData?.id, type, typeState])
  return (
    <>
      {!newsItem && <Loading shown={!newsItem} />}
      {!!newsItem && (
        <Container
          id="spot-light-wrapper"
          style={{
            display: 'flex',
            flexDirection: 'column',
            // backgroundImage: `linear-gradient(  rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.9), rgb(255, 255, 255), rgb(255, 255, 255), rgb(255, 255, 255), rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0.03), rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0.07), rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0.09), rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.11), rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.13), rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.16), rgba(0, 0, 0, 0.17), rgba(0, 0, 0, 0.18), rgba(0, 0, 0, 0.19), rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.21), rgba(0, 0, 0, 0.22), rgba(0, 0, 0, 0.23), rgba(0, 0, 0, 0.24), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.26), rgba(0, 0, 0, 0.27), rgba(0, 0, 0, 0.28), rgba(0, 0, 0, 0.29), rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.31), rgba(0, 0, 0, 0.32), rgba(0, 0, 0, 0.33), rgba(0, 0, 0, 0.34), rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.36), rgba(0, 0, 0, 0.37), rgba(0, 0, 0, 0.38), rgba(0, 0, 0, 0.39), rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.41), rgba(0, 0, 0, 0.42), rgba(0, 0, 0, 0.43), rgba(0, 0, 0, 0.44), rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.46), rgba(0, 0, 0, 0.47), rgba(0, 0, 0, 0.48), rgba(0, 0, 0, 0.49), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.51), rgba(0, 0, 0, 0.52), rgba(0, 0, 0, 0.53), rgba(0, 0, 0, 0.54), rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.56), rgba(0, 0, 0, 0.57), rgba(0, 0, 0, 0.58), rgba(0, 0, 0, 0.59), rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.61), rgba(0, 0, 0, 0.62), rgba(0, 0, 0, 0.63), rgba(0, 0, 0, 0.64), rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.66), rgba(0, 0, 0, 0.67), rgba(0, 0, 0, 0.68), rgba(0, 0, 0, 0.69), rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.71), rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0.73), rgba(0, 0, 0, 0.74), rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.76), rgba(0, 0, 0, 0.76), rgba(0, 0, 0, 0.76))`,
          }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              paddingLeft: paddingWrapper,
              paddingTop: '1.4375rem',
              zIndex: 1,
              background:
                'linear-gradient(180deg, #F2F4F4 0%, #F3F5F5 10%, #F5F7F7 20%, #F6F8F8 30%, #F8F9F9 40%, #FAFBFB 50%, #FBFCFC 60%, #FCFCFC 70%, #FDFDFD 80%, #FDFEFE 90%, #FFFFFF 100%), linear-gradient(180deg, #FFFFFF 0%, #F2F4F4 100%)',
            }}>
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <mask
                id="mask0_3505_3292"
                style={{
                  maskType: 'luminance',
                }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="30"
                height="30">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M30 15C30 23.2849 23.2841 30 15.0005 30C6.71588 30 0 23.2849 0 15C0 6.71512 6.71588 0 15.0005 0C23.2841 0 30 6.71512 30 15Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_3505_3292)">
                <rect width="30" height="30" fill="#A8A8A8" />
                <path
                  opacity="0.55"
                  d="M2.4751 6.74999L7.9501 19.65L25.3501 19.125L8.4751 1.49999L8.25536 1.6077C5.89662 2.76395 3.89809 4.5419 2.4751 6.74999Z"
                  fill="white"
                />
                <ellipse
                  cx="16.725"
                  cy="19.575"
                  rx="8.775"
                  ry="2.475"
                  fill="white"
                />
              </g>
            </svg>
            <h2
              style={{
                margin: 0,
                fontSize: '1.3125rem',
                marginLeft: '0.8125rem',
              }}>
              Spotlight
            </h2>
          </div>
          <InformationModal2
            isAuthed={isAuthed}
            InfoModalUL={`Futures Platform's Spotlight-tool utilises the latest AI-capabilities to provide a new way to visualising content. In Spotlight, the news article is surrounded by multiple phenomena which are connected to topic of the article. You will discover phenomena across domains to ensure a holistic view. This provides a way to show the article in a wider context to understand the driving forces and areas of impact, and to broaden your perspective. Click a related phenomenon or news article to open it in the Spotlight view.`}
            InfoModalUL2={
              !isAuthed ? 'Remember to log in to enable the features!' : null
            }
            // InfoModalDescription2="Instruct the division of work: who writes which scenario."
            // InfoModalDescription3="Define how many paragraphs there should be in each narrative, and how long the paragraphs should be."
            // InfoModalDescription4="Indicate what perspectives (3-6) all writers should cover when writing their scenario, and in which order those should appear. Perspectives can be e.g. General context, Economic development, or Impacts for the organisation."
            // InfoModalDescription5="For development paths, define how many events are need in each scenario."
            // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
            // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
            // how many events are need in each scenario."
            // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
            // style should be followed?"
            InfoModalHeader={'Spotlight view'}
            // InfoModalNote={
            //   'A short and distinctive name to your scenario project'
            // }
            InfoModalOpen={isInfoModalShown}
            InfoModalClose={() => setisInfoModalShown(false)}
            LearnMoreBtn={'How the Spotlight works?'}
            LearnMoreLink="https://info.futuresplatform.com/en/hub/spotlight-view"
          />
          <InformationModal
            isAuthed={isAuthed}
            videoModalClosedHandler={videoModalClosedHandler}
            InfoModalOpen={isVideoModalOpened}
            InfoModalClose={() => setisVideoModalOpened(false)}
          />
          <div
            style={{
              display: 'flex',
              position: 'absolute',
              top: '1.4375rem',
              right: widthOfView > 600 ? '16px' : '16px',
              zIndex: 998,
              cursor: 'pointer',
              alignItems: 'center',

              // marginRight: !!openFullScreenMode ? '-8px' : 'unset',
            }}>
            <div
              id="X-spotlight-btn"
              className="nav-item"
              style={{
                opacity: 1,
              }}>
              <a
                style={{
                  cursor: 'pointer',
                }}
                onMouseOver={() => {
                  setIsHover(() => true)
                }}
                onMouseOut={() => {
                  setIsHover(() => false)
                }}
                onClick={() => '/phenomena'}
                href={'/phenomena'}
                className="btn-icon-lg">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <rect
                    x="1.62988"
                    y="3.51562"
                    width="2.66667"
                    height="26.6667"
                    rx="1.33333"
                    transform="rotate(-45 1.62988 3.51562)"
                    fill={!isHover ? '#637282' : '#689AB9'}
                  />
                  <rect
                    x="3.51538"
                    y="22.3718"
                    width="2.66667"
                    height="26.6667"
                    rx="1.33333"
                    transform="rotate(-135 3.51538 22.3718)"
                    fill={!isHover ? '#637282' : '#689AB9'}
                  />
                </svg>
              </a>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              position: 'absolute',
              bottom: !openFullScreenMode ? '16px' : 'unset',
              right: paddingWrapper,
              top: !!openFullScreenMode ? '4px' : 'unset',
              zIndex: 999999999,
              // marginRight: !!openFullScreenMode ? '-8px' : 'unset',
            }}>
            {/webOS|iPhone|iPad|iPod/i.test(navigator.userAgent) !== true &&
            (openFullScreenMode === false || !openFullScreenMode) ? (
              <FullScreenBtn
                onClick={openFullScreenModeHandle}
                className="btn-fullscreen-custom"
                style={{ position: 'fixed' }}>
                {/* <span>Fullscreen</span> */}
              </FullScreenBtn>
            ) : null}
            {/webOS|iPhone|iPad|iPod/i.test(navigator.userAgent) !== true &&
            (openFullScreenMode === true || !!openFullScreenMode) ? (
              <FullScreenBtn
                onClick={closeFullScreenModeHandle}
                className="btn-fullscreen-custom-exit"
                style={{ position: 'fixed' }}>
                {/* <span>Fullscreen</span> */}
              </FullScreenBtn>
            ) : null}
            {/* {!!openFullScreenMode &&
          /webOS|iPhone|iPad|iPod/i.test(navigator.userAgent) !== true && (
            <FullscreenExitWrapperBtn
              // style={{
              //   color: '#5d5d5d',
              // }}
              className="btn-icon-lg"
              onClick={closeFullScreenModeHandle}>
              <span className="af-custom-close" />
            </FullscreenExitWrapperBtn>
          )} */}
          </div>
          <div
            className="radar-nav"
            id="radar-nav-bottomleft"
            style={{
              zIndex: 19999,
              left: paddingWrapper,
              bottom: '12px',
              position: 'fixed',
            }}>
            <HubLink
              onMouseOver={() => {
                setisHubSpotBtnHover(() => true)
              }}
              onMouseOut={() => {
                setisHubSpotBtnHover(() => false)
              }}
              isActive={isAuthed}
              className="btn-round btn-lg d-flex align-items-center justify-content-center"
              target="_blank"
              rel="noopener noreferrer"
              // href={requestTranslation('infoUrl')}
              onClick={!!isAuthed ? infoIconHandler : null}
              style={{
                position: 'relative !important',
                cursor: `${!!isAuthed && 'pointer'}`,
              }}>
              {!isAuthed ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 12.0001C0 5.38327 5.3832 0 12 0C18.6168 0 24 5.38327 24 12.0001C24 18.6169 18.6168 24 12 24C5.3832 24 0 18.6169 0 12.0001ZM2.18182 12.0001C2.18182 17.4138 6.58618 21.8182 12 21.8182C17.4137 21.8182 21.8182 17.4138 21.8182 12.0001C21.8182 6.58633 17.4138 2.18182 12 2.18182C6.58618 2.18182 2.18182 6.58633 2.18182 12.0001Z"
                    fill="#C2D0D7"
                  />
                  <path
                    d="M12.0001 5.33331C11.2649 5.33331 10.6667 5.93171 10.6667 6.66725C10.6667 7.40211 11.2649 7.99998 12.0001 7.99998C12.7353 7.99998 13.3334 7.40211 13.3334 6.66725C13.3334 5.93171 12.7353 5.33331 12.0001 5.33331Z"
                    fill="#C2D0D7"
                  />
                  <path
                    d="M12.0001 10.6667C11.2637 10.6667 10.6667 11.1144 10.6667 11.6667V17.6667C10.6667 18.219 11.2637 18.6667 12.0001 18.6667C12.7364 18.6667 13.3334 18.219 13.3334 17.6667V11.6667C13.3334 11.1144 12.7364 10.6667 12.0001 10.6667Z"
                    fill="#C2D0D7"
                  />
                </svg>
              ) : (
                <>
                  {!isHubSpotBtnHover ? (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 12.0001C0 5.38327 5.3832 0 12 0C18.6168 0 24 5.38327 24 12.0001C24 18.6169 18.6168 24 12 24C5.3832 24 0 18.6169 0 12.0001ZM2.18182 12.0001C2.18182 17.4138 6.58618 21.8182 12 21.8182C17.4137 21.8182 21.8182 17.4138 21.8182 12.0001C21.8182 6.58633 17.4138 2.18182 12 2.18182C6.58618 2.18182 2.18182 6.58633 2.18182 12.0001Z"
                        fill="#E8EBEB"
                      />
                      <path
                        d="M12.0001 5.33331C11.2649 5.33331 10.6667 5.93171 10.6667 6.66725C10.6667 7.40211 11.2649 7.99998 12.0001 7.99998C12.7353 7.99998 13.3334 7.40211 13.3334 6.66725C13.3334 5.93171 12.7353 5.33331 12.0001 5.33331Z"
                        fill="#E8EBEB"
                      />
                      <path
                        d="M12.0001 10.6667C11.2637 10.6667 10.6667 11.1144 10.6667 11.6667V17.6667C10.6667 18.219 11.2637 18.6667 12.0001 18.6667C12.7364 18.6667 13.3334 18.219 13.3334 17.6667V11.6667C13.3334 11.1144 12.7364 10.6667 12.0001 10.6667Z"
                        fill="#E8EBEB"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0 12.0001C0 5.38327 5.3832 0 12 0C18.6168 0 24 5.38327 24 12.0001C24 18.6169 18.6168 24 12 24C5.3832 24 0 18.6169 0 12.0001ZM2.18182 12.0001C2.18182 17.4138 6.58618 21.8182 12 21.8182C17.4137 21.8182 21.8182 17.4138 21.8182 12.0001C21.8182 6.58633 17.4138 2.18182 12 2.18182C6.58618 2.18182 2.18182 6.58633 2.18182 12.0001Z"
                        fill="#689AB9"
                      />
                      <path
                        d="M12.0001 5.33331C11.2649 5.33331 10.6667 5.93171 10.6667 6.66725C10.6667 7.40211 11.2649 7.99998 12.0001 7.99998C12.7353 7.99998 13.3334 7.40211 13.3334 6.66725C13.3334 5.93171 12.7353 5.33331 12.0001 5.33331Z"
                        fill="#689AB9"
                      />
                      <path
                        d="M12.0001 10.6667C11.2637 10.6667 10.6667 11.1144 10.6667 11.6667V17.6667C10.6667 18.219 11.2637 18.6667 12.0001 18.6667C12.7364 18.6667 13.3334 18.219 13.3334 17.6667V11.6667C13.3334 11.1144 12.7364 10.6667 12.0001 10.6667Z"
                        fill="#689AB9"
                      />
                    </svg>
                  )}
                </>
              )}
            </HubLink>
          </div>
          <TableWrapper
            style={{
              // width: '100%',
              marginTop: 0,
              // marginBottom: '40px',
              position: 'relative',
              paddingTop: '1.375rem',
              paddingLeft: paddingWrapper,
              paddingRight:
                widthOfView > 700
                  ? paddingWrapper
                  : `calc(${paddingWrapper} + 8px)`,
            }}>
            <RowWrapper>
              <Row
                style={{
                  marginTop: '24px',
                  fontSize: '11.5px',
                }}>
                <Year>2040</Year>
                <Line></Line>
              </Row>
              <Row
                style={{
                  marginTop: '44px',
                  fontSize: '12px',
                }}>
                <Year>2035</Year>
                <Line></Line>
              </Row>
              <Row
                style={{
                  marginTop: '64px',
                  fontSize: '13px',
                }}>
                <Year>2030</Year>
                <Line></Line>
              </Row>
              <Row
                style={{
                  marginTop: '84px',
                  fontSize: '13.5px',
                }}>
                <Year id="year-2025">2025</Year>
                <Line></Line>
              </Row>
              <Row
                style={{
                  marginTop: '104px',
                  fontSize: '14px',
                }}>
                <Year>NOW</Year>
                <Line></Line>
              </Row>
            </RowWrapper>
            <ContentCardWrapper>
              {!!recomended_phenomena &&
                recomended_phenomena?.map((card, index) => {
                  return (
                    <ContentCard
                      isAuthed={isAuthed}
                      href={getPhenomenonUrl(false, card)}
                      key={index}
                      phenomenon={card}
                      lang={card?.language}
                      phenomenonType={phenTypes}
                    />
                  )
                })}
            </ContentCardWrapper>
          </TableWrapper>

          {/* 
      {!!tags?.length && (
        <OptionsWrapper>
          <DropdownWrapper>
            <OptionDropdown
              style={{
                marginLeft: '16px',
                marginRight: '16px',
                color: '#636161',
                fontWeight: 'unset',
              }}
              // label={requestTranslation('group')}
              title={'# ' + selectedGroup1?.value}
              type={'radio'}
              optionsShown={isOptionDropdown1Opened}
              options={dropdownOptions}
              selectedOption={selectedGroup1}
              onTabClick={() => {
                setisOptionDropdown1Opened(() => !isOptionDropdown1Opened)
              }}
              handleOptionSelect={async (e) => {
                setSelectedGroup1(() => {
                  return find(dropdownOptions, {
                    label: e.target.textContent || e.target.innerText,
                  })
                })

                try {
                  const payload = {
                    'news-id': null,
                    'tag-1': e.target.textContent || e.target.innerText,
                    'tag-2': selectedGroup2?.value,
                    'tag-3': selectedGroup3?.value,
                  }

                  const [spotlight, phenomenonType, crowdsourcedData] =
                    await Promise.all([
                      spotlightAPIs.getSpotLight(payload),
                      getPhenomenaTypes(0),
                      // fetcher.getStatistics(),
                      null,
                    ])

                  const recommeded_phenomena =
                    !!spotlight.data?.recommeded_phenomena?.length &&
                    spotlight.data?.recommeded_phenomena?.filter((phen) => {
                      if (
                        !!phen?.content?.time_range?.min &&
                        !!phen?.content?.time_range?.max
                      )
                        return phen
                    })
                  setphenTypes(() => phenomenonType)
                  setrecomendedNewsState(() => spotlight.data?.recommeded_news)
                  setrecomendedPhenState(() => recommeded_phenomena)
                  setTags(() => spotlight.data?.tags)
                  setnewsItem(() => spotlight.data?.source)

                  // return {
                  //   spotLight: spotlight.data,
                  //   phenomenonType: phenomenonType,
                  //   crowdsourcedData: crowdsourcedData?.data,
                  // }
                } catch (error) {}

                setisOptionDropdown1Opened(() => false)
                setisOptionDropdown2Opened(() => false)
                setisOptionDropdown3Opened(() => false)
              }}
              nameRadio="group-filters-1"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <OptionDropdown
              // label={requestTranslation('group')}
              title={'# ' + selectedGroup2?.value}
              type={'radio'}
              optionsShown={isOptionDropdown2Opened}
              options={dropdownOptions}
              selectedOption={selectedGroup2}
              onTabClick={() => {
                setisOptionDropdown2Opened(() => !isOptionDropdown2Opened)
              }}
              handleOptionSelect={async (e) => {
                setSelectedGroup2(
                  find(dropdownOptions, {
                    label: e.target.textContent || e.target.innerText,
                  }),
                )

                try {
                  const payload = {
                    'news-id': null,
                    'tag-1': selectedGroup1?.value,
                    'tag-2': e.target.textContent || e.target.innerText,
                    'tag-3': selectedGroup3?.value,
                  }

                  const [spotlight, phenomenonType, crowdsourcedData] =
                    await Promise.all([
                      spotlightAPIs.getSpotLight(payload),
                      getPhenomenaTypes(0),
                      // fetcher.getStatistics(),
                      null,
                    ])

                  const recommeded_phenomena =
                    !!spotlight.data?.recommeded_phenomena?.length &&
                    spotlight.data?.recommeded_phenomena?.filter((phen) => {
                      if (
                        !!phen?.content?.time_range?.min &&
                        !!phen?.content?.time_range?.max
                      )
                        return phen
                    })
                  setphenTypes(() => phenomenonType)
                  setrecomendedNewsState(() => spotlight.data?.recommeded_news)
                  setrecomendedPhenState(() => recommeded_phenomena)
                  setTags(() => spotlight.data?.tags)
                  setnewsItem(() => spotlight.data?.source)

                  // return {
                  //   spotLight: spotlight.data,
                  //   phenomenonType: phenomenonType,
                  //   crowdsourcedData: crowdsourcedData?.data,
                  // }
                } catch (error) {}

                setisOptionDropdown1Opened(() => false)
                setisOptionDropdown2Opened(() => false)
                setisOptionDropdown3Opened(() => false)
              }}
              nameRadio="group-filters-2"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <OptionDropdown
              // label={requestTranslation('group')}
              title={'# ' + selectedGroup3?.value}
              type={'radio'}
              optionsShown={isOptionDropdown3Opened}
              options={dropdownOptions}
              selectedOption={selectedGroup3}
              onTabClick={() => {
                setisOptionDropdown3Opened(() => !isOptionDropdown3Opened)
              }}
              handleOptionSelect={async (e) => {
                setSelectedGroup3(
                  find(dropdownOptions, {
                    label: e.target.textContent || e.target.innerText,
                  }),
                )

                try {
                  const payload = {
                    'news-id': null,
                    'tag-1': selectedGroup1?.value,
                    'tag-2': selectedGroup2?.value,
                    'tag-3': e.target.textContent || e.target.innerText,
                  }

                  const [spotlight, phenomenonType, crowdsourcedData] =
                    await Promise.all([
                      spotlightAPIs.getSpotLight(payload),
                      getPhenomenaTypes(0),
                      // fetcher.getStatistics(),
                      null,
                    ])

                  const recommeded_phenomena =
                    !!spotlight.data?.recommeded_phenomena?.length &&
                    spotlight.data?.recommeded_phenomena?.filter((phen) => {
                      if (
                        !!phen?.content?.time_range?.min &&
                        !!phen?.content?.time_range?.max
                      )
                        return phen
                    })
                  setphenTypes(() => phenomenonType)
                  setrecomendedNewsState(() => spotlight.data?.recommeded_news)
                  setrecomendedPhenState(() => recommeded_phenomena)
                  setTags(() => spotlight.data?.tags)
                  setnewsItem(() => spotlight.data?.source)

                  // return {
                  //   spotLight: spotlight.data,
                  //   phenomenonType: phenomenonType,
                  //   crowdsourcedData: crowdsourcedData?.data,
                  // }
                } catch (error) {}

                setisOptionDropdown1Opened(() => false)
                setisOptionDropdown2Opened(() => false)
                setisOptionDropdown3Opened(() => false)
              }}
              nameRadio="group-filters-3"
            />
          </DropdownWrapper>
        </OptionsWrapper>
      )} */}
          <div
            className="news-wrapper"
            style={{
              zIndex: 1, // marginTop: !!isAuthed
              //   ? !openFullScreenMode
              //     ? '5rem'
              //     : '13rem'
              //   : '125px',

              paddingTop: '4rem',
              flex: '1 1 100%',
              position: 'relative',
              minHeight: 'calc(100% - 438px - 54px)',
              background:
                'linear-gradient(180deg, #FFFFFF 0%, #E4E4E4 25%, #B9B9B9 50%, #A0A0A0 75%, #595959 100%)',
            }}>
            {!!newsData && (
              <div
                style={{
                  position: 'relative',
                  zIndex: 1,
                }}>
                <NewsWrapper
                  id="main-news"
                  style={
                    {
                      // marginTop: '4rem',
                    }
                  }>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '8px',
                    }}>
                    <TagWrapper isMainContent={true}>
                      {newsData?.theme}
                    </TagWrapper>
                    <p
                      style={{
                        fontWeight: 500,
                        fontSize: '0.6875rem',
                        margin: 0,
                        color: 'rgb(99, 114, 130)',
                      }}>
                      {typeState === 'news'
                        ? 'NEWS'
                        : typeState === 'phenomenon'
                        ? 'PHENOMENON'
                        : 'SCENARIO'}
                    </p>
                  </div>
                  <NewsTitleWrapper
                    style={{
                      alignItems: widthOfView > 600 ? 'center' : 'unset',
                    }}>
                    <NewsTitleWrapper2>
                      {/* <NewsIcon>Icon-news</NewsIcon> */}
                      <NewsTitle
                        // data-uri={dataURI}
                        data-href={typeState !== 'news' && dataHref}
                        data-uri={typeState !== 'news' && dataUri}
                        className={typeState !== 'news' && classNameMainContent}
                        onClick={() => {
                          typeState === 'news' &&
                            // !!isAuthed &&
                            window.open(`${newsData?.content?.link}`)
                        }}>
                        {newsData?.content?.title?.substring(0, 100) +
                          (newsData?.content?.title?.length > 100 ? '...' : '')}
                      </NewsTitle>
                    </NewsTitleWrapper2>
                    {/* <NewsFlag src={flagIcon}></NewsFlag> */}

                    {/* for now, hidding the bookmark feature for phenom and scenario, will show it when 
                      refactoring the place that user can find the bookmarked data, like Content explorer page
                    */}
                    {typeState === 'news' && (
                      <FlagIcon
                        isAuthed={isAuthed}
                        newsData={newsItem}
                        widthOfView={widthOfView}
                        isNewsBookMarked={!!isAuthed ? isNewsBookMarked : false}
                        // color="#000000"
                        width="24px"
                        height="24px"
                        handler={() => !!isAuthed && newsBookmarkHandler()}
                      />
                    )}
                  </NewsTitleWrapper>
                  <NewsDescription
                    // data-uri={dataURI}
                    data-href={typeState !== 'news' && dataHref}
                    data-uri={typeState !== 'news' && dataUri}
                    className={typeState !== 'news' && classNameMainContent}
                    onClick={() => {
                      typeState === 'news' &&
                        // !!isAuthed &&
                        window.open(`${newsData?.content?.link}`)
                    }}
                    style={{
                      width: widthOfView > 600 ? '65%' : '100%',
                    }}>
                    {
                      stripHtml(
                        !!newsData?.content?.summary
                          ? newsData?.content?.summary?.substring(0, 200)
                          : newsData?.content?.title?.substring(0, 200),
                      )?.result
                    }{' '}
                    {newsData?.content?.summary?.length > 200 ? '...' : ''}
                  </NewsDescription>
                  <NewsFooterWrapper
                    style={{
                      flexDirection: widthOfView > 600 ? 'row' : 'column',
                      alignItems: widthOfView > 600 ? 'center' : 'unset',
                    }}>
                    <NewsPublisherWrapper>
                      {typeState === 'news' ? (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 12.4183 12.4183 16 8 16C3.576 16 0 12.4 0 8C0 3.58172 3.58172 0 8 0ZM8 14.4C11.5346 14.4 14.4 11.5346 14.4 8C14.4 4.46538 11.5346 1.6 8 1.6C4.46538 1.6 1.6 4.46538 1.6 8C1.6 11.5346 4.46538 14.4 8 14.4ZM8.4 8.2V4H7.2V8.8L11.4 11.32L12 10.336L8.4 8.2Z"
                              fill="#121212"
                            />
                          </svg>
                          <NewsAuthor>
                            {newsData?.content?.extracted?.publisher?.substring(
                              0,
                              20,
                            ) ||
                              newsData?.content?.extracted?.author?.substring(
                                0,
                                20,
                              ) ||
                              ''}
                          </NewsAuthor>
                          <NewsTime
                            style={{
                              marginLeft: widthOfView > 600 ? '6px' : '0',
                            }}>
                            {normalisedTimeFormat(newsData?.updated_at)}
                          </NewsTime>
                        </div>
                      ) : (
                        <>
                          {typeState === 'phenomenon' ? (
                            <CardHeaderOnMainContent
                              gid={gid}
                              pid={newsData?.id}
                              phenomenon={newsData}
                              lang={'en'}
                              phenomenonType={phenTypes}
                            />
                          ) : (
                            <CardHeaderScenarioOnMainContent
                              scenario={newsData}
                            />
                          )}
                        </>
                      )}
                    </NewsPublisherWrapper>
                    <NewsCTAsBtnWrapper
                      style={{
                        marginTop: widthOfView > 600 ? 0 : '16px',
                        justifyContent:
                          widthOfView > 600 ? 'unset' : 'space-between',
                      }}>
                      <div
                        style={{
                          display: 'flex',
                          marginRight: '24px',
                          // marginRight: !!openFullScreenMode ? '-8px' : 'unset',
                        }}>
                        <BackBtnIconWrapper
                          onMouseOver={() => {
                            setisHoverBackBtn(() => true)
                          }}
                          onMouseOut={() => {
                            setisHoverBackBtn(() => false)
                          }}
                          style={{
                            // transform: 'scaleX(-1)',
                            marginRight: '12px',
                            cursor: 'pointer',
                            // marginRight: !!openFullScreenMode ? '-8px' : 'unset',
                          }}
                          onClick={() => {
                            const indexAt = spotLightListRef.current?.reduce(
                              function (cur, val, index) {
                                if (
                                  val?.spotlight?.source?.id === newsId &&
                                  cur === -1
                                ) {
                                  return index
                                }
                                return cur
                              },
                              -1,
                            )

                            if (Number(indexAt) > 0) {
                              backBtnNewsHandler()
                            }
                          }}>
                          {!isBackNarrowBtnDisabled ? (
                            <>
                              {!isHoverBackBtn ? (
                                <svg
                                  width="30"
                                  height="30"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <mask
                                    id="mask0_3505_3240"
                                    style={{
                                      maskType: 'luminance',
                                    }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="30"
                                    height="30">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M30 15C30 23.2849 23.2841 30 15.0005 30C6.71588 30 0 23.2849 0 15C0 6.71512 6.71588 0 15.0005 0C23.2841 0 30 6.71512 30 15Z"
                                      fill="white"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_3505_3240)">
                                    <rect
                                      width="30"
                                      height="30"
                                      fill="#E8EBEB"
                                    />
                                    <path
                                      d="M29.1666 15C29.1666 22.824 22.824 29.1666 14.9999 29.1666C7.17588 29.1666 0.833252 22.824 0.833252 15C0.833252 7.17595 7.17588 0.833313 14.9999 0.833313C22.824 0.833313 29.1666 7.17595 29.1666 15Z"
                                      fill="white"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M12.3432 14.3675L16.4176 10.2593C16.7605 9.91355 17.3166 9.91355 17.6595 10.2593C18.0025 10.6051 18.0025 11.1658 17.6595 11.5116L14.1998 15L17.6595 18.4884C18.0025 18.8342 18.0025 19.3949 17.6595 19.7407C17.3166 20.0864 16.7605 20.0864 16.4176 19.7407L12.3432 15.6325C11.9968 15.2832 11.9968 14.7168 12.3432 14.3675Z"
                                      fill="white"
                                    />
                                    <mask
                                      id="mask1_3505_3240"
                                      style={{
                                        maskType: 'luminance',
                                      }}
                                      maskUnits="userSpaceOnUse"
                                      x="12"
                                      y="10"
                                      width="6"
                                      height="10">
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M12.3432 14.3675L16.4176 10.2593C16.7605 9.91355 17.3166 9.91355 17.6595 10.2593C18.0025 10.6051 18.0025 11.1658 17.6595 11.5116L14.1998 15L17.6595 18.4884C18.0025 18.8342 18.0025 19.3949 17.6595 19.7407C17.3166 20.0864 16.7605 20.0864 16.4176 19.7407L12.3432 15.6325C11.9968 15.2832 11.9968 14.7168 12.3432 14.3675Z"
                                        fill="white"
                                      />
                                    </mask>
                                    <g mask="url(#mask1_3505_3240)">
                                      <rect
                                        x="5"
                                        y="5"
                                        width="20"
                                        height="20"
                                        fill="#637282"
                                      />
                                    </g>
                                  </g>
                                </svg>
                              ) : (
                                <svg
                                  width="30"
                                  height="30"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <mask
                                    id="mask0_3505_3240"
                                    style={{
                                      maskType: 'luminance',
                                    }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="30"
                                    height="30">
                                    <path
                                      fillRule="evenodd"
                                      clip-rule="evenodd"
                                      d="M30 15C30 23.2849 23.2841 30 15.0005 30C6.71588 30 0 23.2849 0 15C0 6.71512 6.71588 0 15.0005 0C23.2841 0 30 6.71512 30 15"
                                      fill="white"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_3505_3240)">
                                    <rect
                                      width="30"
                                      height="30"
                                      fill="#E8EBEB"
                                    />
                                    <path
                                      d="M29.1666 15C29.1666 22.824 22.824 29.1666 14.9999 29.1666C7.17588 29.1666 0.833252 22.824 0.833252 15C0.833252 7.17595 7.17588 0.833313 14.9999 0.833313C22.824 0.833313 29.1666 7.17595 29.1666 15Z"
                                      fill="white"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M12.3432 14.3675L16.4176 10.2593C16.7605 9.91355 17.3166 9.91355 17.6595 10.2593C18.0025 10.6051 18.0025 11.1658 17.6595 11.5116L14.1998 15L17.6595 18.4884C18.0025 18.8342 18.0025 19.3949 17.6595 19.7407C17.3166 20.0864 16.7605 20.0864 16.4176 19.7407L12.3432 15.6325C11.9968 15.2832 11.9968 14.7168 12.3432 14.3675V14.3675Z"
                                      fill="white"
                                    />
                                    <mask
                                      id="mask1_3505_3240"
                                      style={{
                                        maskType: 'luminance',
                                      }}
                                      maskUnits="userSpaceOnUse"
                                      x="12"
                                      y="10"
                                      width="6"
                                      height="10">
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M12.3432 14.3675L16.4176 10.2593C16.7605 9.91355 17.3166 9.91355 17.6595 10.2593C18.0025 10.6051 18.0025 11.1658 17.6595 11.5116L14.1998 15L17.6595 18.4884C18.0025 18.8342 18.0025 19.3949 17.6595 19.7407C17.3166 20.0864 16.7605 20.0864 16.4176 19.7407L12.3432 15.6325C11.9968 15.2832 11.9968 14.7168 12.3432 14.3675V14.3675Z"
                                        fill="white"
                                      />
                                    </mask>
                                    <g mask="url(#mask1_3505_3240)">
                                      <rect
                                        x="5"
                                        y="5"
                                        width="20"
                                        height="20"
                                        fill="#689AB9"
                                      />
                                    </g>
                                  </g>
                                </svg>
                              )}
                            </>
                          ) : (
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <mask
                                id="mask0_3505_3240"
                                style={{
                                  maskType: 'luminance',
                                }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="30"
                                height="30">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M30 15C30 23.2849 23.2841 30 15.0005 30C6.71588 30 0 23.2849 0 15C0 6.71512 6.71588 0 15.0005 0C23.2841 0 30 6.71512 30 15Z"
                                  fill="white"
                                />
                              </mask>
                              <g mask="url(#mask0_3505_3240)">
                                <rect width="30" height="30" fill="#E8EBEB" />
                                <path
                                  d="M29.1666 15C29.1666 22.824 22.824 29.1666 14.9999 29.1666C7.17588 29.1666 0.833252 22.824 0.833252 15C0.833252 7.17595 7.17588 0.833313 14.9999 0.833313C22.824 0.833313 29.1666 7.17595 29.1666 15Z"
                                  fill="white"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M12.3432 14.3675L16.4176 10.2593C16.7605 9.91355 17.3166 9.91355 17.6595 10.2593C18.0025 10.6051 18.0025 11.1658 17.6595 11.5116L14.1998 15L17.6595 18.4884C18.0025 18.8342 18.0025 19.3949 17.6595 19.7407C17.3166 20.0864 16.7605 20.0864 16.4176 19.7407L12.3432 15.6325C11.9968 15.2832 11.9968 14.7168 12.3432 14.3675Z"
                                  fill="white"
                                />
                                <mask
                                  id="mask1_3505_3240"
                                  style={{
                                    maskType: 'luminance',
                                  }}
                                  maskUnits="userSpaceOnUse"
                                  x="12"
                                  y="10"
                                  width="6"
                                  height="10">
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12.3432 14.3675L16.4176 10.2593C16.7605 9.91355 17.3166 9.91355 17.6595 10.2593C18.0025 10.6051 18.0025 11.1658 17.6595 11.5116L14.1998 15L17.6595 18.4884C18.0025 18.8342 18.0025 19.3949 17.6595 19.7407C17.3166 20.0864 16.7605 20.0864 16.4176 19.7407L12.3432 15.6325C11.9968 15.2832 11.9968 14.7168 12.3432 14.3675Z"
                                    fill="white"
                                  />
                                </mask>
                                <g mask="url(#mask1_3505_3240)">
                                  <rect
                                    x="5"
                                    y="5"
                                    width="20"
                                    height="20"
                                    fill="#C2D0D7"
                                  />
                                </g>
                              </g>
                            </svg>
                          )}
                        </BackBtnIconWrapper>
                        <NextBtnIconWrapper
                          style={{
                            cursor: 'pointer',
                          }}
                          onMouseOver={() => {
                            setisHoverNextBtn(() => true)
                          }}
                          onMouseOut={() => {
                            setisHoverNextBtn(() => false)
                          }}
                          onClick={() => {
                            const indexAt = spotLightListRef.current?.reduce(
                              function (cur, val, index) {
                                if (
                                  val?.spotlight?.source?.id === newsId &&
                                  cur === -1
                                ) {
                                  return index
                                }
                                return cur
                              },
                              -1,
                            )
                            if (
                              Number(indexAt) <
                              spotLightListRef.current?.length - 1
                            ) {
                              nextBtnNewsHandler()
                            }
                          }}>
                          {!isNextNarrowBtnDisabled ? (
                            <>
                              {!isHoverNextBtn ? (
                                <svg
                                  width="30"
                                  height="30"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <mask
                                    id="mask0_3505_3239"
                                    style={{
                                      maskType: 'luminance',
                                    }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="30"
                                    height="30">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M30 15C30 23.2849 23.2841 30 15.0005 30C6.71588 30 0 23.2849 0 15C0 6.71512 6.71588 0 15.0005 0C23.2841 0 30 6.71512 30 15"
                                      fill="white"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_3505_3239)">
                                    <rect
                                      width="30"
                                      height="30"
                                      fill="#E8EBEB"
                                    />
                                    <path
                                      d="M29.1666 15C29.1666 22.824 22.824 29.1666 14.9999 29.1666C7.17588 29.1666 0.833252 22.824 0.833252 15C0.833252 7.17595 7.17588 0.833313 14.9999 0.833313C22.824 0.833313 29.1666 7.17595 29.1666 15Z"
                                      fill="white"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M17.6568 15.6325L13.5824 19.7407C13.2395 20.0864 12.6834 20.0864 12.3405 19.7407C11.9975 19.3949 11.9975 18.8342 12.3405 18.4884L15.8002 15L12.3405 11.5116C11.9975 11.1658 11.9975 10.6051 12.3405 10.2593C12.6834 9.91355 13.2395 9.91355 13.5824 10.2593L17.6568 14.3675C18.0032 14.7168 18.0032 15.2832 17.6568 15.6325V15.6325Z"
                                      fill="white"
                                    />
                                  </g>
                                  <mask
                                    id="mask1_3505_3239"
                                    style={{
                                      maskType: 'luminance',
                                    }}
                                    maskUnits="userSpaceOnUse"
                                    x="12"
                                    y="10"
                                    width="6"
                                    height="10">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M17.6568 15.6325L13.5824 19.7407C13.2395 20.0864 12.6834 20.0864 12.3405 19.7407C11.9975 19.3949 11.9975 18.8342 12.3405 18.4884L15.8002 15L12.3405 11.5116C11.9975 11.1658 11.9975 10.6051 12.3405 10.2593C12.6834 9.91355 13.2395 9.91355 13.5824 10.2593L17.6568 14.3675C18.0032 14.7168 18.0032 15.2832 17.6568 15.6325V15.6325Z"
                                      fill="white"
                                    />
                                  </mask>
                                  <g mask="url(#mask1_3505_3239)">
                                    <rect
                                      x="5"
                                      y="5"
                                      width="20"
                                      height="20"
                                      fill="#637282"
                                    />
                                  </g>
                                </svg>
                              ) : (
                                <svg
                                  width="30"
                                  height="30"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <mask
                                    id="mask0_3505_3239"
                                    style={{
                                      maskType: 'luminance',
                                    }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="30"
                                    height="30">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M30 15C30 23.2849 23.2841 30 15.0005 30C6.71588 30 0 23.2849 0 15C0 6.71512 6.71588 0 15.0005 0C23.2841 0 30 6.71512 30 15"
                                      fill="white"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_3505_3239)">
                                    <rect
                                      width="30"
                                      height="30"
                                      fill="#E8EBEB"
                                    />
                                    <path
                                      d="M29.1666 15C29.1666 22.824 22.824 29.1666 14.9999 29.1666C7.17588 29.1666 0.833252 22.824 0.833252 15C0.833252 7.17595 7.17588 0.833313 14.9999 0.833313C22.824 0.833313 29.1666 7.17595 29.1666 15Z"
                                      fill="white"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M17.6568 15.6325L13.5824 19.7407C13.2395 20.0864 12.6834 20.0864 12.3405 19.7407C11.9975 19.3949 11.9975 18.8342 12.3405 18.4884L15.8002 15L12.3405 11.5116C11.9975 11.1658 11.9975 10.6051 12.3405 10.2593C12.6834 9.91355 13.2395 9.91355 13.5824 10.2593L17.6568 14.3675C18.0032 14.7168 18.0032 15.2832 17.6568 15.6325V15.6325Z"
                                      fill="white"
                                    />
                                  </g>
                                  <mask
                                    id="mask1_3505_3239"
                                    style={{
                                      maskType: 'luminance',
                                    }}
                                    maskUnits="userSpaceOnUse"
                                    x="12"
                                    y="10"
                                    width="6"
                                    height="10">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M17.6568 15.6325L13.5824 19.7407C13.2395 20.0864 12.6834 20.0864 12.3405 19.7407C11.9975 19.3949 11.9975 18.8342 12.3405 18.4884L15.8002 15L12.3405 11.5116C11.9975 11.1658 11.9975 10.6051 12.3405 10.2593C12.6834 9.91355 13.2395 9.91355 13.5824 10.2593L17.6568 14.3675C18.0032 14.7168 18.0032 15.2832 17.6568 15.6325V15.6325Z"
                                      fill="white"
                                    />
                                  </mask>
                                  <g mask="url(#mask1_3505_3239)">
                                    <rect
                                      x="5"
                                      y="5"
                                      width="20"
                                      height="20"
                                      fill="#689AB9"
                                    />
                                  </g>
                                </svg>
                              )}
                            </>
                          ) : (
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <mask
                                id="mask0_3505_3239"
                                style={{
                                  maskType: 'luminance',
                                }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="30"
                                height="30">
                                <path
                                  fillRule="evenodd"
                                  clip-rule="evenodd"
                                  d="M30 15C30 23.2849 23.2841 30 15.0005 30C6.71588 30 0 23.2849 0 15C0 6.71512 6.71588 0 15.0005 0C23.2841 0 30 6.71512 30 15"
                                  fill="white"
                                />
                              </mask>
                              <g mask="url(#mask0_3505_3239)">
                                <rect width="30" height="30" fill="#E8EBEB" />
                                <path
                                  d="M29.1666 15C29.1666 22.824 22.824 29.1666 14.9999 29.1666C7.17588 29.1666 0.833252 22.824 0.833252 15C0.833252 7.17595 7.17588 0.833313 14.9999 0.833313C22.824 0.833313 29.1666 7.17595 29.1666 15Z"
                                  fill="white"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M17.6568 15.6325L13.5824 19.7407C13.2395 20.0864 12.6834 20.0864 12.3405 19.7407C11.9975 19.3949 11.9975 18.8342 12.3405 18.4884L15.8002 15L12.3405 11.5116C11.9975 11.1658 11.9975 10.6051 12.3405 10.2593C12.6834 9.91355 13.2395 9.91355 13.5824 10.2593L17.6568 14.3675C18.0032 14.7168 18.0032 15.2832 17.6568 15.6325V15.6325Z"
                                  fill="white"
                                />
                              </g>
                              <mask
                                id="mask1_3505_3239"
                                style={{
                                  maskType: 'luminance',
                                }}
                                maskUnits="userSpaceOnUse"
                                x="12"
                                y="10"
                                width="6"
                                height="10">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M17.6568 15.6325L13.5824 19.7407C13.2395 20.0864 12.6834 20.0864 12.3405 19.7407C11.9975 19.3949 11.9975 18.8342 12.3405 18.4884L15.8002 15L12.3405 11.5116C11.9975 11.1658 11.9975 10.6051 12.3405 10.2593C12.6834 9.91355 13.2395 9.91355 13.5824 10.2593L17.6568 14.3675C18.0032 14.7168 18.0032 15.2832 17.6568 15.6325V15.6325Z"
                                  fill="white"
                                />
                              </mask>
                              <g mask="url(#mask1_3505_3239)">
                                <rect
                                  x="5"
                                  y="5"
                                  width="20"
                                  height="20"
                                  fill="#C2D0D7"
                                />
                              </g>
                            </svg>
                          )}
                        </NextBtnIconWrapper>
                      </div>

                      <NewsSharesWrapper>
                        {!!isSharedModalOpened && (
                          <ShareModalWrapper ref={shareWrapperRef}>
                            <SocialSharesWrapper>
                              <SocialShare
                                id="shared-by-linkedin"
                                data-href={
                                  'id=' +
                                  newsItem?.id +
                                  '/title=' +
                                  newsData?.content?.title +
                                  '?shared-by-linkedin' +
                                  '/data_of_news' +
                                  JSON.stringify(newsItem)
                                }>
                                <LinkedinShareButton
                                  url={
                                    hostname +
                                    '/spotlight/' +
                                    newsItem?.id +
                                    '?content=' +
                                    typeState
                                  }
                                  style={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}>
                                  <EmailBtn className="af-custom-linkedin"></EmailBtn>
                                  <div>
                                    {!!newsItem && newsItem?.language === 'en'
                                      ? 'Share in LinkedIn'
                                      : 'Jaa LinkedInissäI'}
                                  </div>
                                </LinkedinShareButton>
                              </SocialShare>

                              <SocialShare
                                id="shared-by-twitter"
                                data-href={
                                  'id=' +
                                  newsItem?.id +
                                  '/title=' +
                                  newsData?.content?.title +
                                  '?shared-by-twitter' +
                                  '/data_of_news' +
                                  JSON.stringify(newsItem)
                                }>
                                <TwitterShareButton
                                  url={
                                    hostname +
                                    '/spotlight/' +
                                    newsItem?.id +
                                    '?content=' +
                                    typeState
                                  }
                                  title={newsItem?.content?.title}
                                  style={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}>
                                  <EmailBtn className="af-custom-twitter"></EmailBtn>
                                  <div>
                                    {!!newsItem && newsItem?.language === 'en'
                                      ? 'Share in Twitter'
                                      : 'Jaa Twitterissä'}
                                  </div>
                                </TwitterShareButton>
                              </SocialShare>

                              <SocialShare
                                id="shared-by-facebook"
                                data-href={
                                  'id=' +
                                  newsItem?.id +
                                  '/title=' +
                                  newsData?.content?.title +
                                  '?shared-by-facebook' +
                                  '/data_of_news' +
                                  JSON.stringify(newsItem)
                                }>
                                <FacebookShareButton
                                  url={
                                    hostname +
                                    '/spotlight/' +
                                    newsItem?.id +
                                    '?content=' +
                                    typeState
                                  }
                                  quote={newsItem?.content?.title}
                                  style={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}>
                                  <EmailBtn className="af-custom-facebook"></EmailBtn>
                                  <div>
                                    {!!newsItem && newsItem?.language === 'en'
                                      ? 'Share in Facebook'
                                      : 'Jaa Facebookissa'}
                                  </div>
                                </FacebookShareButton>
                              </SocialShare>

                              <SocialShare
                                id="shared-by-email"
                                data-href={
                                  'id=' +
                                  newsItem?.id +
                                  '/title=' +
                                  newsData?.content?.title +
                                  '?shared-by-email' +
                                  '/data_of_news' +
                                  JSON.stringify(newsItem)
                                }>
                                <EmailShareButton
                                  IsBodyHtml={true}
                                  openShareDialogOnClick
                                  onClick={() => {}}
                                  // url={hostname + '/spotlight/' + newsItem?.id}
                                  url={''}
                                  subject={`[Shared from FP:] ${newsItem?.content?.title}`}
                                  body={`Hi!

A new way to dive into the ${typeState}! Click this link to open this ${typeState} in the Spotlight by Futures Platform:

${hostname}/spotlight/${newsItem?.id}?content=${typeState}`}
                                  // className="Demo__some-network__share-button"
                                  style={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}>
                                  <EmailBtn className="af-custom-mail"></EmailBtn>
                                  <div>
                                    {!!newsItem && newsItem?.language === 'en'
                                      ? 'Share by Email'
                                      : 'Jaa Sähköpostitse'}
                                  </div>
                                </EmailShareButton>
                              </SocialShare>
                            </SocialSharesWrapper>
                          </ShareModalWrapper>
                        )}
                        <SharedBtnWrapper
                          ref={sharedBtnRef}
                          onMouseOver={() => {
                            setIsHoverShareBtn(() => true)
                          }}
                          onMouseOut={() => {
                            setIsHoverShareBtn(() => false)
                          }}
                          onClick={(event) =>
                            shareSocialBtnsHandler(newsItem, event)
                          }>
                          <SwichNewsIconWrapper
                            style={{
                              marginLeft: 0,
                              marginRight: '0.0625rem',
                              cursor: 'pointer',
                            }}
                            // onClick={(event) =>
                            //   shareSocialBtnsHandler(newsItem, event)
                            // }
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle
                                cx="16.2648"
                                cy="17.6471"
                                r="1.85294"
                                fill={!isHoverShareBtn ? '#637282' : '#689AB9'}
                                stroke={
                                  !isHoverShareBtn ? '#637282' : '#689AB9'
                                }
                              />
                              <circle
                                cx="16.2648"
                                cy="6.35294"
                                r="1.85294"
                                fill={!isHoverShareBtn ? '#637282' : '#689AB9'}
                                stroke={
                                  !isHoverShareBtn ? '#637282' : '#689AB9'
                                }
                              />
                              <circle
                                cx="6.85294"
                                cy="12"
                                r="1.85294"
                                fill={!isHoverShareBtn ? '#637282' : '#689AB9'}
                                stroke={
                                  !isHoverShareBtn ? '#637282' : '#689AB9'
                                }
                              />
                              <line
                                x1="18.0292"
                                y1="5.54581"
                                x2="6.73511"
                                y2="12.134"
                                stroke={
                                  !isHoverShareBtn ? '#637282' : '#689AB9'
                                }
                                strokeWidth="1.4"
                              />
                              <line
                                x1="6.73503"
                                y1="11.8659"
                                x2="18.0292"
                                y2="18.4542"
                                stroke={
                                  !isHoverShareBtn ? '#637282' : '#689AB9'
                                }
                                strokeWidth="1.4"
                              />
                            </svg>
                          </SwichNewsIconWrapper>
                          {/* <SharedBtn
                      isActive={!!isSharedModalOpened}
                      onClick={(event) =>
                        shareSocialBtnsHandler(newsItem, event)
                      }>
                      <span className="af-custom-share-light"> </span>
                    </SharedBtn> */}
                          <span
                            style={{
                              // marginLeft: '24px',
                              color: `${
                                !isHoverShareBtn ? '#637282' : '#689AB9'
                              }`,
                              fontWeight: 500,
                              fontSize: '0.6875rem',
                            }}>
                            {' '}
                            {!!newsItem && newsItem?.language === 'en'
                              ? 'SHARE'
                              : 'JAA'}
                          </span>
                        </SharedBtnWrapper>
                      </NewsSharesWrapper>

                      <NewsCTABtn
                        id="open-news-article"
                        data-href={typeState !== 'news' && dataHref}
                        data-uri={typeState !== 'news' && dataUri}
                        onClick={() => {
                          typeState === 'news' &&
                            // !!isAuthed &&
                            window.open(newsItem?.content?.link)
                        }}
                        className={`btn btn-primary ${classNameMainContent}`}
                        style={{
                          // fontSize: '16px',
                          fontSize: widthOfView > 600 ? '14px' : '11.5px',
                        }}>
                        {!!newsItem && newsItem?.language === 'en'
                          ? 'OPEN'
                          : 'AVAA'}
                      </NewsCTABtn>
                    </NewsCTAsBtnWrapper>
                  </NewsFooterWrapper>
                </NewsWrapper>
                <div
                  ref={reflectorRef}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'absolute',
                    bottom: '-4.375rem',
                    // bottom: `calc(-${heightOfReflector}px / ${
                    //   widthOfView < 600 ? 3 : 2.3
                    // }) 5rem)}`, // calc(-169px / 2.3 + 5rem)
                    zIndex: '1',
                  }}>
                  <svg
                    style={{
                      width: '100%',
                      height: '135px',
                    }}
                    preserveAspectRatio="none"
                    width="1200"
                    height="135"
                    viewBox="0 0 1200 135"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.34" filter="url(#filter0_d_3505_3185)">
                      <path
                        d="M1200 88.5749V38.4252L600 1L0 38.4252V88.5749L600 126L1200 88.5749Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_3505_3185"
                        x="-5"
                        y="0"
                        width="1210"
                        height="135"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2.5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_3505_3185"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_3505_3185"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div>
              </div>
            )}

            {!!recomendedNewsState?.length && (
              <SliderWrapper
                style={{
                  position: 'relative',
                  zIndex: 2,
                  border: 'none',
                  // backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.70), rgba(255, 255, 255, 0.60), rgba(255, 255, 255, 0.50), rgba(255, 255, 255, 0.40), rgba(255, 255, 255, 0.30), rgba(255, 255, 255, 0.20), rgba(255, 255, 255, 0.10), rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))`,
                  // padding: widthOfView > 800 ? '12px 52px' : '4px',
                }}>
                <Slider {...settings} className="slider-spotslight">
                  {!!recomendedNewsState?.length &&
                    recomendedNewsState?.map((item, index) => {
                      return (
                        <SliderItemWrapper
                          // paddingProp={
                          //   widthOfView > 800 ? '14px' : '4px'
                          // }
                          style={{
                            // opacity: 0.8,
                            // padding:
                            //   widthOfView > 800
                            //     ? '14px!important'
                            //     : '2px!important',
                            border: 'none',
                            backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.70), rgba(255, 255, 255, 0.60), rgba(255, 255, 255, 0.50), rgba(255, 255, 255, 0.40), rgba(255, 255, 255, 0.30), rgba(255, 255, 255, 0.20), rgba(255, 255, 255, 0.10), rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))`,
                          }}
                          data-href={JSON.stringify(item)}
                          className="slider-card-spotlight related-news"
                          key={index}>
                          {!!item?.theme && (
                            <TagWrapper
                              style={{
                                marginBottom: '0.4rem',
                              }}>
                              {item?.theme}
                            </TagWrapper>
                          )}
                          <SubNewsHeaderSectionWrapper>
                            <SubNewsTitle
                              onClick={() => {
                                window.open(item?.content?.link || null)
                              }}>
                              {item?.content?.title?.substring(0, 70)}{' '}
                              {item?.content?.title?.length > 70 ? '...' : ''}
                            </SubNewsTitle>
                            <SwichNewsIconWrapper
                              style={{
                                marginLeft: 0,
                                marginRight: 0,
                                cursor: 'pointer',
                              }}
                              onClick={async (e) => {
                                if (!!isAuthed) {
                                  e.stopPropagation()
                                  e.preventDefault()
                                  const typeOfThisContent =
                                    item?.type === 'phenomenon'
                                      ? 'phenomenon'
                                      : item?.type === 'news-feed-item'
                                      ? 'news'
                                      : 'scenario'
                                  settypeState(() => typeOfThisContent)
                                  NProgress.start()
                                  NProgress.set(0.5)

                                  setnewsId(() => item?.id)

                                  setisOptionDropdown1Opened(() => false)
                                  setisOptionDropdown2Opened(() => false)
                                  setisOptionDropdown3Opened(() => false)

                                  try {
                                    const payload = {
                                      groups: !!isAuthed
                                        ? [...groupsIds, 0]
                                        : [0],
                                      userId: !!isAuthed ? getUserId() : -1,
                                      // 'news-id': item?.id,
                                      // 'tag-1': null,
                                      // 'tag-2': null,
                                      // 'tag-3': null,
                                    }

                                    const [
                                      spotlightRes,
                                      phenomenonType1,
                                      getStatus1BookmarkNews,
                                      crowdsourcedData,
                                    ] = await Promise.all([
                                      spotlightAPIs.getSpotLight(
                                        typeOfThisContent,
                                        item?.id,
                                        payload,
                                      ),
                                      // mockData,
                                      !!isAuthed
                                        ? getPhenomenaTypes(
                                            item?.groups?.length
                                              ? item?.groups[0]
                                              : 0,
                                          )
                                        : spotlightAPIs.getPhenomenaTypesGroup0(),
                                      !!isAuthed
                                        ? spotlightAPIs.getStatus1BookmarkNews(
                                            `${
                                              item?.groups?.length
                                                ? item?.groups[0]
                                                : 0
                                            }/${typeState}/${item?.id}`,
                                          )
                                        : null,
                                      // fetcher.getStatistics(),
                                      null,
                                    ])
                                    const spotlight = !!spotlightRes
                                      ? { ...spotlightRes }
                                      : {}

                                    const phenomenonType = !isAuthed
                                      ? phenomenonType1?.data
                                      : phenomenonType1
                                    const bookmarkEntityUriSplited =
                                      !!getStatus1BookmarkNews?.data.length &&
                                      getStatus1BookmarkNews?.data[0]?.entityUri?.split(
                                        '/',
                                      )

                                    const newsIdFromEntityUriRes =
                                      !!bookmarkEntityUriSplited
                                        ? bookmarkEntityUriSplited[4]
                                        : false

                                    if (newsIdFromEntityUriRes === item?.id) {
                                      setisNewsBookMarked(true)
                                    } else {
                                      setisNewsBookMarked(false)
                                    }

                                    // const recommeded_phenomena =
                                    //   !!spotlight.data?.recommeded_phenomena?.length &&
                                    //   spotlight.data?.recommeded_phenomena
                                    //     ?.filter((phen) => {
                                    //       if (
                                    //         !!phen?.content?.time_range?.min &&
                                    //         !!phen?.content?.time_range?.max
                                    //       )
                                    //         return phen
                                    //     })
                                    //     ?.slice(0, 12)

                                    const lang =
                                      spotlight.data?.source?.language
                                    const recommended_phenomenaTemp =
                                      !!spotlight.data?.recommeded_phenomena
                                        ?.length
                                        ? [
                                            ...spotlight.data
                                              ?.recommeded_phenomena,
                                          ]
                                        : []
                                    let recommeded_phenomena =
                                      !!recommended_phenomenaTemp?.length &&
                                      recommended_phenomenaTemp
                                        ?.filter((phen) => {
                                          if (
                                            !!phen?.content?.time_range?.min &&
                                            !!phen?.content?.time_range?.max
                                          )
                                            return phen
                                        })
                                        ?.filter((n) => {
                                          if (n?.language === lang) return n
                                        })
                                        ?.slice(0, 12)
                                    let recommeded_phenomenaNotTimeRange = []
                                    if (
                                      !!recommeded_phenomena?.length &&
                                      recommeded_phenomena?.length < 12
                                    ) {
                                      recommeded_phenomenaNotTimeRange =
                                        !!recommended_phenomenaTemp?.length &&
                                        recommended_phenomenaTemp
                                          ?.filter((phen) => {
                                            if (
                                              !phen?.content?.time_range?.min ||
                                              !phen?.content?.time_range?.max
                                            )
                                              phen.content['time_range'] = {
                                                min: 2040,
                                                max: 2040,
                                              }
                                            return phen
                                          })
                                          ?.filter((n) => {
                                            if (n?.language === lang) return n
                                          })
                                    }

                                    if (
                                      !recommeded_phenomena?.length ||
                                      recommeded_phenomena?.length < 12
                                    ) {
                                      let i = 0
                                      while (
                                        !!recommeded_phenomena?.length &&
                                        recommeded_phenomena?.length < 13 &&
                                        i < recommeded_phenomena?.length
                                      ) {
                                        // eslint-disable-next-line no-loop-func
                                        const isNotSame =
                                          recomended_phenomena?.every(
                                            // eslint-disable-next-line no-loop-func
                                            (rn) => {
                                              if (
                                                String(rn?.id) ===
                                                String(
                                                  recommeded_phenomenaNotTimeRange[
                                                    i
                                                  ]?.id,
                                                )
                                              ) {
                                                return false
                                              }
                                            },
                                          )

                                        if (!!isNotSame) {
                                          !!recommeded_phenomenaNotTimeRange[
                                            i
                                          ] &&
                                            recommeded_phenomena?.push(
                                              recommeded_phenomenaNotTimeRange[
                                                i
                                              ],
                                            )
                                        }
                                        i += 1
                                      }
                                    }

                                    NProgress.done(true)
                                    NProgress.remove()
                                    setnewsItem(() => spotlight.data?.source)

                                    setgid(() =>
                                      item?.groups?.length
                                        ? item?.groups[0]
                                        : 0,
                                    )

                                    setphenTypes(() =>
                                      !!isAuthed
                                        ? phenomenonType1
                                        : phenomenonType1?.data,
                                    )
                                    setrecomendedNewsState(
                                      () => spotlight.data?.recommedded_news,
                                    )
                                    setrecomendedPhenState(
                                      () => recommeded_phenomena,
                                    )
                                    setTags(() => spotlight.data?.tags)
                                    let a = spotLightListRef.current.filter(
                                      (n) => n?.id === item?.id,
                                    )
                                    if (!!a?.length) {
                                      const b = spotLightListRef.current.filter(
                                        (n) => n?.id !== item?.id,
                                      )
                                      spotLightListRef.current = b
                                    }

                                    spotLightListRef.current.push({
                                      spotlight: {
                                        ...spotlight.data,
                                        recommeded_phenomena:
                                          recommeded_phenomena || [],
                                      },
                                      phenomenonType: !!isAuthed
                                        ? phenomenonType1
                                        : phenomenonType1?.data,
                                      getStatus1BookmarkNews:
                                        getStatus1BookmarkNews?.data,
                                    })
                                    setisNeed2ScrollToMainNews(() => true)
                                  } catch (error) {}
                                }
                              }}
                              onMouseOver={() => {
                                setisHoverSwitchToMainNews(() => true)
                              }}
                              onMouseOut={() => {
                                setisHoverSwitchToMainNews(() => false)
                              }}>
                              {!isAuthed ? (
                                <svg
                                  width="30"
                                  height="30"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <mask
                                    id="mask0_3505_3218"
                                    style={{
                                      maskType: 'luminance',
                                    }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="30"
                                    height="30">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M30 15C30 23.2849 23.2841 30 15.0005 30C6.71588 30 0 23.2849 0 15C0 6.71512 6.71588 0 15.0005 0C23.2841 0 30 6.71512 30 15Z"
                                      fill="white"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_3505_3218)">
                                    <rect width="30" height="30" fill="white" />
                                    <rect
                                      width="30"
                                      height="30"
                                      fill="#E8EBEB"
                                    />
                                    <path
                                      d="M29.1666 15C29.1666 22.824 22.824 29.1666 14.9999 29.1666C7.17588 29.1666 0.833252 22.824 0.833252 15C0.833252 7.17594 7.17588 0.833313 14.9999 0.833313C22.824 0.833313 29.1666 7.17594 29.1666 15Z"
                                      fill="white"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M11.6868 15.0202C11.3718 14.7053 11.5949 14.1667 12.0404 14.1667L17.9595 14.1667C18.4049 14.1667 18.628 14.7053 18.313 15.0202L15.3535 17.9798C15.1582 18.1751 14.8416 18.1751 14.6464 17.9798L11.6868 15.0202Z"
                                      fill="#C2D0D7"
                                    />
                                    <rect
                                      x="14.1667"
                                      y="8.33331"
                                      width="1.66667"
                                      height="6.66667"
                                      rx="0.833333"
                                      fill="#C2D0D7"
                                    />
                                    <ellipse
                                      cx="14.9999"
                                      cy="20.8334"
                                      rx="6.66667"
                                      ry="1.66667"
                                      fill="#C2D0D7"
                                    />
                                  </g>
                                </svg>
                              ) : (
                                <>
                                  {!isHoverSwitchToMainNews ? (
                                    <svg
                                      width="30"
                                      height="30"
                                      viewBox="0 0 30 30"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <mask
                                        id="mask0_3505_3218"
                                        style={{
                                          maskType: 'luminance',
                                        }}
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="30"
                                        height="30">
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M30 15C30 23.2849 23.2841 30 15.0005 30C6.71588 30 0 23.2849 0 15C0 6.71512 6.71588 0 15.0005 0C23.2841 0 30 6.71512 30 15Z"
                                          fill="white"
                                        />
                                      </mask>
                                      <g mask="url(#mask0_3505_3218)">
                                        <rect
                                          width="30"
                                          height="30"
                                          fill="white"
                                        />
                                        <rect
                                          width="30"
                                          height="30"
                                          fill="#E8EBEB"
                                        />
                                        <path
                                          d="M29.1666 15C29.1666 22.824 22.824 29.1666 14.9999 29.1666C7.17588 29.1666 0.833252 22.824 0.833252 15C0.833252 7.17594 7.17588 0.833313 14.9999 0.833313C22.824 0.833313 29.1666 7.17594 29.1666 15Z"
                                          fill="white"
                                        />
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M11.6868 15.0202C11.3718 14.7053 11.5949 14.1667 12.0404 14.1667L17.9595 14.1667C18.4049 14.1667 18.628 14.7053 18.313 15.0202L15.3535 17.9798C15.1582 18.1751 14.8416 18.1751 14.6464 17.9798L11.6868 15.0202Z"
                                          fill="#637282"
                                        />
                                        <rect
                                          x="14.1667"
                                          y="8.33331"
                                          width="1.66667"
                                          height="6.66667"
                                          rx="0.833333"
                                          fill="#637282"
                                        />
                                        <ellipse
                                          cx="14.9999"
                                          cy="20.8334"
                                          rx="6.66667"
                                          ry="1.66667"
                                          fill="#637282"
                                        />
                                      </g>
                                    </svg>
                                  ) : (
                                    <svg
                                      width="30"
                                      height="30"
                                      viewBox="0 0 30 30"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <mask
                                        id="mask0_3505_3218"
                                        style={{
                                          maskType: 'luminance',
                                        }}
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="30"
                                        height="30">
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M30 15C30 23.2849 23.2841 30 15.0005 30C6.71588 30 0 23.2849 0 15C0 6.71512 6.71588 0 15.0005 0C23.2841 0 30 6.71512 30 15Z"
                                          fill="white"
                                        />
                                      </mask>
                                      <g mask="url(#mask0_3505_3218)">
                                        <rect
                                          width="30"
                                          height="30"
                                          fill="white"
                                        />
                                        <rect
                                          width="30"
                                          height="30"
                                          fill="#E8EBEB"
                                        />
                                        <path
                                          d="M29.1666 15C29.1666 22.824 22.824 29.1666 14.9999 29.1666C7.17588 29.1666 0.833252 22.824 0.833252 15C0.833252 7.17594 7.17588 0.833313 14.9999 0.833313C22.824 0.833313 29.1666 7.17594 29.1666 15Z"
                                          fill="white"
                                        />
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M11.6868 15.0202C11.3718 14.7053 11.5949 14.1667 12.0404 14.1667L17.9595 14.1667C18.4049 14.1667 18.628 14.7053 18.313 15.0202L15.3535 17.9798C15.1582 18.1751 14.8416 18.1751 14.6464 17.9798L11.6868 15.0202Z"
                                          fill="#689AB9"
                                        />
                                        <rect
                                          x="14.1667"
                                          y="8.33331"
                                          width="1.66667"
                                          height="6.66667"
                                          rx="0.833333"
                                          fill="#689AB9"
                                        />
                                        <ellipse
                                          cx="14.9999"
                                          cy="20.8334"
                                          rx="6.66667"
                                          ry="1.66667"
                                          fill="#689AB9"
                                        />
                                      </g>
                                    </svg>
                                  )}
                                </>
                              )}
                            </SwichNewsIconWrapper>
                          </SubNewsHeaderSectionWrapper>
                          <SubNewsFooterWrapper>
                            <SubNewsPublisherInfo>
                              <svg
                                width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M5 0C6.32608 0 7.59785 0.526784 8.53553 1.46447C9.47322 2.40215 10 3.67392 10 5C10 7.76142 7.76142 10 5 10C2.235 10 0 7.75 0 5C0 2.23858 2.23858 0 5 0ZM5 9C7.20914 9 9 7.20914 9 5C9 2.79086 7.20914 1 5 1C2.79086 1 1 2.79086 1 5C1 7.20914 2.79086 9 5 9ZM5.25 5.125V2.5H4.5V5.5L7.125 7.075L7.5 6.46L5.25 5.125Z"
                                  fill="#637282"
                                />
                              </svg>

                              <NewsAuthor
                                style={{
                                  // fontSize: '16px',
                                  color: '#637282',
                                  fontSize: '0.5625rem',
                                }}>
                                {item?.content?.extracted?.publisher?.substring(
                                  0,
                                  20,
                                ) ||
                                  item?.content?.extracted?.author?.substring(
                                    0,
                                    20,
                                  ) ||
                                  ''}{' '}
                                {'  '} {normalisedTimeFormat(item?.updated_at)}
                              </NewsAuthor>
                              {/* <NewsTime>
                          {normalisedTimeFormat(item?.updated_at)}
                        </NewsTime> */}
                            </SubNewsPublisherInfo>
                          </SubNewsFooterWrapper>
                        </SliderItemWrapper>
                      )
                    })}
                </Slider>
              </SliderWrapper>
            )}
          </div>
        </Container>
      )}
    </>
  )
}
export default App
const Controls = ({ zoomIn, zoomOut, resetTransform }) => (
  <>
    <button onClick={() => zoomIn()}>+</button>
    <button onClick={() => zoomOut()}>-</button>
    <button onClick={() => resetTransform()}>x</button>
  </>
)
export const NewsCTABtn = styled.button`
  cursor: pointer;
  text-transform: uppercase;
  // font-size: 16px !important;
`

export const Container = styled.div`
  width: 100%;
  height: auto;
  // background: rgb(232, 235, 235);
  position: relative;
`
export const DropdownWrapper = styled.div`
  height: fit-content;
  margin-left: 4px;
  margin-right: 4px;
  width: calc(24% - 8px);
  hyphens: auto;
  word-break: break-word;
  over-flow: auto;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07),
    0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07),
    0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07);
`

export const NewsWrapper = styled.div`
  position: relative;
  z-index: 2;
  width: 80%;
  height: fit-content;
  margin: auto;
  background: #ffffff;
  padding: 1rem 2.5rem 1rem 2.5rem;
  border-radius: 8px;
  // box-shadow: 0 1px 1px rgba(0, 0, 0, 0.11), 0 2px 2px rgba(0, 0, 0, 0.11),
  //   0 4px 4px rgba(0, 0, 0, 0.11), 0 6px 8px rgba(0, 0, 0, 0.11),
  //   0 8px 16px rgba(0, 0, 0, 0.11);
`
export const NewsTitleWrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  padding-bottom: 12px;
  // align-items: center;
  align-items: center;
`
export const NewsTitleWrapper2 = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
`

export const NewsIcon = styled.image`
  width: 36px;
  height: 36px;
`
export const NewsTitle = styled.h2`
  width: fit-content;
  height: fit-content;
  // padding-left: 32px;
  // padding-right: 32px;
  font-size: 1.375rem;
  font-weight: 700;
  margin: 0;
  color: #121212;
  cursor: pointer;
`

export const NewsFlag = styled.img`
  width: 24px;
  height: 24px;
  margin-top: 4px;
  // padding-left: 32px;
`
export const NewsDescription = styled.p`
  width: 65%;
  max-height: 200px;
  // padding-left: 32px;
  // padding-right: 32px;
  overflow: hidden;
  word-break: break-all;
  font-weight: 400;
  font-size: 0.75rem;
  margin-bottom: 12px;
  hyphens: auto;
  word-break: break-word;
  over-flow: auto;
  color: #121212;
  cursor: pointer;
`

export const NewsFooterWrapper = styled.div`
  width: 100%;
  height: fit-content;
  // padding-left: 32px;
  // padding-right: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgb(119, 119, 119);
`

export const NewsPublisherWrapper = styled.div`
  font-size: 13px;
  color: rgb(119, 119, 119);
  display: flex;
  align-items: center;
`
export const NewsCTAsBtnWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const NewsAuthor = styled.span`
  // height: 17.25px;
  hyphens: auto;
  word-break: break-word;
  over-flow: auto;
  color: #121212;
  margin-left: 0.3125rem;
  font-size: 0.75rem;
  font-weight: 500;
`
export const NewsTime = styled.span`
  width: fit-content;
  height: fit-content;
  margin-left: 6px;
  // height: 17.25px;
  hyphens: auto;
  word-break: break-word;
  over-flow: auto;
  color: #121212;
  font-size: 0.75rem;
  font-weight: 500;
`
export const NewsSharesWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  margin-right: 24px;
`
export const SliderWrapper = styled.div`
  border-radius: 16px;
  width: 80%;
  height: fit-content;
  margin: auto;
  margin-top: 2px;
  // background: rgba(146, 146, 146, 0.12);
  padding: 12px 0 12px 0;
  border-radius: 16px;
  // box-shadow: 0 2px 1px rgba(0, 0, 0, 0.09), 0 4px 2px rgba(0, 0, 0, 0.09),
  //   0 8px 4px rgba(0, 0, 0, 0.09), 0 16px 8px rgba(0, 0, 0, 0.09),
  //   0 32px 16px rgba(0, 0, 0, 0.09);
  // height: 5rem;
`
export const TableWrapper = styled.div`
  height: fit-content;
  display: flex;
  // justify-content: center;
  positon: relative;
  background: rgba(255, 255, 255, 1);
  z-index: 2;
`
export const OptionsWrapper = styled.div`
  width: 72%;
  height: auto;
  display: flex;
  justify-content: center;
  margin: auto;
  z-index: 99999;
  margin-top: 16px;
  margin-bottom: 4px;
`
export const ContentCardWrapper = styled.div`
  width: calc(100% - 7.5rem);
  height: auto;
  position: absolute;
`

export const RowWrapper = styled.div`
  width: 100%;
  height: fit-content;
  // margin-top: 32px;
  // margin-bottom: 32px;
`
export const Row = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
`
export const Year = styled.div`
  width: calc(32px + 3.75rem);
  height: auto;
`
export const Line = styled.div`
  width: 100%;
  height: 1px;
  background: #e8ebeb;
`
const ShareModalWrapper = styled.div`
  justify-content: center;
  align-items: center;
  align-content: center;
  display: flex;
  z-index: 11111;
  position: absolute;
  width: fit-content;
  height: fit-content;
  font-size: 1rem;
  right: 0;
  background: #fafafa;
  color: #212529;
  top: 0;
  background-clip: padding-box;
  border: 0 solid #e9e9e9;
  border-radius: 0;
  margin: 1px 0 0;
  padding: 8px 16px 8px 12px;
  padding-bottom: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`
const SocialSharesWrapper = styled.div`
  display: flex;
  width: fit-content;
  height: fit-content;
  flex-direction: column;
`

const SocialShare = styled.div`
  margin: 8px;
`
const EmailBtn = styled.span`
  &::before {
    padding: 10px;
  }
  color: rgb(0, 0, 0);
`
const SliderItemWrapper = styled.div`
  // padding: ${(props) => props?.paddingProp};
  height: auto;
  padding: 0.625rem 1.25rem 0.625rem 1.25rem;
`
const SharedBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: #006998;
    // background-color: #f2f2f2;
  }
`
const SharedBtn = styled.button`
  display: inline-block;
  border-radius: 100%;
  width: 32px;
  height: 32px;
  line-height: 32px;
  padding: 0;
  text-align: center;
  font-size: 15px;
  transition: all 0.15s ease-in-out;
  box-shadow: 0px 2px 3px 0px rgb(0 0 0 / 10%);
  background-color: ${(props) => (!!props.isActive ? '#f2f2f2' : '#ffffff')};
  color: #006998;
  border: 1px solid #dee2e6;
  line-height: 31px;
  cursor: pointer;
  margin-right: 8px;
  text-decoration: none;
  background: white;
  &:hover {
    color: #006998;
    background-color: #f2f2f2;
  }
`

const SubNewsHeaderSectionWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`

const SwitchNewsIcon = styled.img`
  width: 32px;
  height: 32px;
`
const SwichNewsIconWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  // background: #e8ebeb;
  // border-radius: 100%;
  // box-shadow: 0px 2px 3px 0px rgb(0 0 0 / 10%);
  // width: 39px;
  // height: 39px;
  // & img:first-child {
  //   width: 39px;
  //   height: 39px;
  // }
  // & img:last-child {
  //   display: none;
  //   width: 0;
  //   height: 0;
  // }
  // &:hover img:last-child {
  //   display: block;
  //   width: 39px;
  //   height: 39px;
  // }
  // &:hover img:first-child {
  //   display: none;
  // }
`
const SubNewsTitle = styled.h6`
  font-size: 0.75rem;
  font-weight: 700;
  margin-bottom: 0;
  width: 82%;
  // margin-right: 16px;
  overflow: auto;
  // hyphens: auto;
  word-break: break-word;
  over-flow: auto;
  margin-top: 0;
  coclor: #121212;
  cursor: pointer;
  min-height: 43.2px;
`

const SubNewsFooterWrapper = styled.div`
  display: flex;
  // font-weight: 600;
  margin-top: 10px;
  // height: 17.25px;
  // position: absolute;
  // bottom: 14px;
`
const SubNewsPublisherInfo = styled.p`
  font-size: 11.5px;
  margin-bottom: 0;
  color: rgb(119, 119, 119);
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const FullscreenWrapperBtn = styled.button`
  color: rgb(255, 255, 255);
  &:hover {
    color: rgb(0, 105, 152);
  }
`
const FullscreenExitWrapperBtn = styled.button`
  color: rgb(255, 255, 255);
  &:hover {
    color: rgb(0, 105, 152);
  }
`

const HubLink = styled.a`
  position: relative !important;
  background: transparent !important;
  box-shadow: none !important;
  text-shadow: none !important;
  &:hover {
    background: transparent !important;
  }
`
const NextBtnIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  & img:last-child {
    display: none;
    width: 0;
    height: 0;
  }
  &:hover img:last-child {
    display: block;
    width: 32px;
    height: 32px;
  }
  &:hover img:first-child {
    display: none;
  }
`

const TagWrapper = styled.div`
  font-size: ${(props) => (!props.isMainContent ? '0.5625rem' : '0.6875rem')};
  color: white;
  background: #689ab9;
  border-radius: 18px;
  font-family: L10;
  font-style: normal;
  font-weight: 500;
  // min-height: 1rem;
  padding-left: ${(props) => (!props.isMainContent ? '0.5625rem' : '1rem')};
  padding-right: ${(props) => (!props.isMainContent ? '0.5625rem' : '1rem')};
  padding-top: ${(props) => (!props.isMainContent ? '0.0625rem' : '0.125rem')};
  padding-bottom: ${(props) =>
    !props.isMainContent ? '0.0625rem' : '0.125rem'};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  margin-right: 0.8125rem;
`
const BackBtnIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  & img:last-child {
    display: none;
    width: 0;
    height: 0;
  }
  &:hover img:last-child {
    display: block;
    width: 32px;
    height: 32px;
  }
  &:hover img:first-child {
    display: none;
  }
`

const FullScreenBtn = styled.button`
  color: rgb(232, 235, 235);

  &:hover {
    color: #689ab9;
  }
`
